// Generated by scripts/wizbuild.mjs. Edit the matching WIZ view.ts instead.
// @ts-nocheck
import { Component as AngularComponent } from '@angular/core';
import Wiz from '../../wiz';
import { OnInit, OnDestroy, signal, computed, inject, afterNextRender, ViewChild, Signal, TemplateRef, ElementRef } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";
import { imageReferences, imageName, imageVersions } from "../../libs/images";
import { PageRefresh, PageRefreshAction } from "../../libs/page-refresh";
import {
  NAV,
  DESCRIPTIONS,
  Item,
  Field,
  items,
  serverChoices,
  compareServers,
  readServerSort,
  saveServerSort,
  errorMessage,
  date,
  status,
  tone,
  percent,
  bytes,
  resourceTone,
  REASONING_OPTIONS,
  reasoningLabel,
  agentAuthLabel,
} from "../../libs/infra";
import { templateFields, templateDefaults, templateInputError, serviceNameError, templateConfiguration, templateInputSummary, templateInputFacts } from "../../libs/templates";
import { inputDefinitionError } from "../../libs/template-input-editor";
import { dnsRecordFields, dnsRecordPayload, dnsSyncTime, dnsConnectionAddresses } from "../../libs/dns";
import { macroAttachmentError, macroRunFields, macroRunPayload, macroAgentDraft } from "../../libs/macros";
import { serviceActions, serviceDomainLabel, serviceDomainName, containerLogLines, containerId, shortContainerId, runtimeState, runtimeHealth, runtimeImage, probeStatus } from "../../libs/service-detail";
const wiz = new Wiz({ appId: 'component.console', namespace: 'console' });
@AngularComponent({
  selector: 'wiz-infra-console',
  templateUrl: './view.html',
  styleUrls: ['./view.scss'],
  standalone: false
})
export class ComponentConsoleComponent implements OnInit, OnDestroy {
  public readonly templateInputFacts = templateInputFacts;
  public templateInputSelectedIndex = 0;
  public router = inject(Router);
  public route = inject(ActivatedRoute);
  private sanitizer = inject(DomSanitizer);
  public reportDocument = signal<SafeHtml | null>(null);
  public reportDocumentError = signal("");
  private reportDocumentSequence = 0;

  public section = "dashboard";
  public id = "";
  public title = "";
  public description = "";
  public icon = "grid";
  public loading = signal(true);
  @ViewChild('dashboard') private dashboard?: { loading: Signal<boolean> };
  public serverContainers = signal<ContainerPanel | undefined>(undefined);
  public fileBrowser = signal<FeedbackPanel | undefined>(undefined);
  public apacheHost = signal<FeedbackPanel | undefined>(undefined);
  // View queries resolve after the template; publish in the next microtask so
  // mounting or removing a tab also refreshes its projected feedback.
  @ViewChild('serverContainers') set containerPanel(value: ContainerPanel | undefined) { queueMicrotask(() => this.serverContainers.set(value)); }
  @ViewChild('fileBrowser') set filePanel(value: FeedbackPanel | undefined) { queueMicrotask(() => this.fileBrowser.set(value)); }
  @ViewChild('apacheHost') set apachePanel(value: FeedbackPanel | undefined) { queueMicrotask(() => this.apacheHost.set(value)); }
  private pageRefresh = inject(PageRefresh);
  private refreshAction: PageRefreshAction = {
    loading: () => this.loading() || !!this.dashboard?.loading() || !!this.serverContainers()?.loading() || (this.section === "images" && this.imageWorking),
    run: () => { if (!this.refreshAction.loading()) void (this.tab === 'containers' && this.serverContainers() ? this.serverContainers()!.load() : this.load()); },
  };
  // Publish after rendering so the parent header observes a fully mounted page.
  private refreshRegistration = afterNextRender(() => this.pageRefresh.current.set(this.refreshAction));
  public headerHeight = signal(72);
  private headerObserver?: ResizeObserver;
  private headerRegistration = afterNextRender(() => {
    const header = document.querySelector<HTMLElement>('.topbar');
    if (!header) return;
    this.headerObserver = new ResizeObserver(() => this.headerHeight.set(Math.ceil(header.getBoundingClientRect().height)));
    this.headerObserver.observe(header);
  });
  public busy = signal(false);
  public error = signal("");
  public notice = signal("");
  public noticeTone = signal<'success' | 'error' | 'warn'>('success');
  public feedbackHeight = signal(0);
  private feedbackObserver?: ResizeObserver;
  @ViewChild('feedbackStack') set feedbackStack(ref: ElementRef<HTMLElement> | undefined) {
    this.feedbackObserver?.disconnect();
    if (!ref) return;
    this.feedbackObserver = new ResizeObserver(() => this.feedbackHeight.set(Math.ceil(ref.nativeElement.getBoundingClientRect().height)));
    this.feedbackObserver.observe(ref.nativeElement);
  }
  public rows = signal<Item[]>([]);
  public detail = signal<Item | null>(null);
  public summary = signal<Item | null>(null);
  public health = signal<Item>({});
  public servers = signal<Item[]>([]);
  public templates = signal<Item[]>([]);
  public zones = signal<Item[]>([]);
  public certificates = signal<Item[]>([]);
  public resources = signal<Item[]>([]);
  public extra = signal<Item[]>([]);
  public operation = signal<Item | null>(null);
  public systemTab = signal("general");
  public readonly systemTabs = [
    {id:"general",label:"일반",icon:"settings"},
    {id:"dns",label:"DNS 연결",icon:"globe"},
    {id:"agent",label:"Agent",icon:"spark"},
    {id:"mail",label:"메일 알림",icon:"inbox"},
  ];
  public agentStatus = signal<Item>({});
  public agentChecking = signal(false);
  public agentError = signal("");
  public agentRelease = signal<Item | null>(null);
  public agentVersionChecking = signal(false);
  public agentVersionError = signal("");
  public reasoningLabel = reasoningLabel;
  public agentAuthLabel = agentAuthLabel;
  private systemSubscription: any;
  private maintenancePolling = false;
  public agentMaintenance = signal<Item | null>(null);
  public metricStats = signal<Item[]>([]);
  public settings = signal<Item>({});
  public dnsAddressesText = "";
  public dnsDefaultAddress = "";
  public wizardDnsAddresses = signal<string[]>([]);
  public get dnsAddressOptions(): string[] { return dnsConnectionAddresses(this.dnsAddressesText); }
  public dnsAddressesChanged(): void {
    if (!this.dnsAddressOptions.includes(this.dnsDefaultAddress)) this.dnsDefaultAddress = "";
  }
  public smtp = signal<Item>({});
  public appearance = signal<Item>({});
  public serverAudit = signal<Item | null>(null);
  public selectedAudit = signal<Set<string>>(new Set());
  public search = "";
  public filter = "";
  public reportPeriod = "";
  public reportFrom = "";
  public reportTo = "";
  public readonly reportPeriods = [
    {value:"",label:"전체"}, {value:"daily",label:"일간"},
    {value:"weekly",label:"주간"}, {value:"monthly",label:"월간"},
  ];
  private get reportQuery(): string {
    if (this.section !== "reports") return "";
    return (this.reportPeriod ? "&period=" + encodeURIComponent(this.reportPeriod) : "")
      + (this.reportFrom ? "&from=" + encodeURIComponent(this.reportFrom) : "")
      + (this.reportTo ? "&to=" + encodeURIComponent(this.reportTo) : "");
  }
  public reportFilterChanged(): void {
    if (this.reportFrom && this.reportTo && this.reportFrom > this.reportTo) {
      this.error.set("시작일은 종료일보다 늦을 수 없습니다.");
      return;
    }
    this.filterChanged();
  }
  public resetReportFilters(): void {
    this.reportPeriod = this.reportFrom = this.reportTo = "";
    this.reportFilterChanged();
  }
  public operationType = "";
  public operationServer = "";
  public operationEventsRemaining = false;
  public operationEventsLoading = signal(false);
  public operationTypesExpanded = false;
  public serverSetupOperation = signal<Item | null>(null);
  public serverDisconnectOperation = signal<Item | null>(null);
  public readonly operationTypes = [
    "deployment-deploy", "server-setup", "server-check", "image-pull", "macro-run",
    "terminal", "anomaly-report", "agent",
    "deployment-start", "deployment-restart", "deployment-stop",
    "deployment-remove", "deployment-change-image", "deployment-rollback",
    "deployment-verify", "service-migration", "service-health",
    "server-optimize", "server-repair", "server-wrapper-upgrade", "server-unregister",
    "image-import", "image-delete", "image-prune", "image-prune-preview",
    "dns", "domain-apache", "apache-host",
    "certificate-issue", "certificate", "certificate-check",
    "agent-template", "agent-report", "agent-apache", "agent-server-audit", "agent-macro",
    "codex-maintenance",
    "container-start", "container-restart", "container-stop", "container-delete", "container-prune", "container-change-image", "container-migrate",
  ];
  public readonly operationStatuses = [
    "queued", "preparing", "running", "verifying", "succeeded", "failed", "canceled",
  ];
  public operationTargetLabel(row: Item): string {
    const label = String(row["targetLabel"] || "")
      .replace(/\s*\[?\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b\]?/gi, "")
      .replace(/\s*·\s*$/, "")
      .trim();
    return label || row["targetType"] || "—";
  }
  public get visibleOperationTypes(): string[] {
    return this.operationTypesExpanded ? this.operationTypes
      : this.operationTypes.filter((type, index) => index < 7 || type === this.operationType);
  }
  private get operationQuery(): string {
    if (this.section !== "operations") return "";
    return (this.filter ? "&status=" + encodeURIComponent(this.filter) : "")
      + (this.operationType ? "&type=" + encodeURIComponent(this.operationType) : "")
      + (this.operationServer ? "&serverId=" + encodeURIComponent(this.operationServer) : "");
  }
  public setOperationFilter(kind: "type" | "status" | "server", value: string): void {
    if (this.loading()) return;
    if (kind === "type") this.operationType = value;
    else if (kind === "server") this.operationServer = value;
    else this.filter = value;
    this.filterChanged();
  }
  public dnsType = "A";
  public readonly dnsTypes = ["A", "AAAA", "CNAME", "TXT", "MX", "CAA", "SRV"];
  public imageSort = "size-desc";
  public serverSort = "name-asc";
  public imageTransferMode: "" | "registry" | "file" = "";
  public pruneMode: "unused" | "selection" | "versions" = "unused";
  public selectedImages = signal<Set<string>>(new Set());
  public selectedPruneImages = signal<Set<string>>(new Set());
  public pruneLoading = signal(false);
  private imageLoadSequence = 0;
  private pruneLoadSequence = 0;
  public imageRefreshing = signal(false);
  private operationPolling = false;
  public get imageWorking(): boolean {
    return this.busy() || this.imageRefreshing() || !!this.operation()?.["type"]?.startsWith("image-");
  }
  public imageRef = imageName;
  public imageVersions = imageVersions;
  public get pruneCandidates(): Item[] {
    return [...(this.prunePreview()?.["candidates"] || [])].sort((a, b) =>
      this.compareImages(a, b),
    );
  }
  public get pruneSelectedBytes(): number {
    return this.pruneCandidates.filter(image => this.selectedPruneImages().has(image["digest"]))
      .reduce((sum, image) => sum + Number(image["size"] || 0), 0);
  }
  public get allPruneSelected(): boolean {
    const candidates = this.pruneCandidates.filter(image => !this.pruneCandidateBlocked(image));
    return candidates.length > 0 && candidates.every(image => this.selectedPruneImages().has(image["digest"]));
  }
  public pruneCandidateBlocked(image: Item): boolean {
    return !!image["protected"] || this.imageUsed(image);
  }
  public pruneCandidateLabel(image: Item): string {
    return this.pruneMode === "versions"
      ? this.imageRef(image) + " " + this.imageVersions(image)
      : this.imageRef(image);
  }
  public togglePrune(image?: Item): void {
    if (this.busy() || (image && this.pruneCandidateBlocked(image))) return;
    const selected = new Set(this.selectedPruneImages());
    if (image) selected.has(image["digest"]) ? selected.delete(image["digest"]) : selected.add(image["digest"]);
    else {
      const allSelected = this.allPruneSelected;
      for (const candidate of this.pruneCandidates.filter(item => !this.pruneCandidateBlocked(item)))
        allSelected ? selected.delete(candidate["digest"]) : selected.add(candidate["digest"]);
    }
    this.selectedPruneImages.set(selected);
  }
  public selectedServices = signal<Map<string, string>>(new Map());
  public page = 1;
  public pageSize = 20;
  public total = 0;
  public selectedServer = "";
  public selectedZone = "";
  public tab = "overview";
  public dateFrom = "";
  public dateTo = "";
  public readonly resourcePeriods = [{hours:24,label:'최근 24시간'},{hours:168,label:'7일'},{hours:720,label:'30일'}];
  public resourcePeriod = 168;
  public resourcesLoading = signal(false);
  public resourceWindow = signal<{from:string;to:string}|null>(null);
  private resourceRequest = 0;
  public modal = signal("");
  public serverConfigurationOpen = signal(false);
  public serverConfigurationError = signal('');
  private serverConfigurationTrigger: HTMLElement | null = null;
  public modalTitle = "";
  public modalDescription = "";
  public modalError = signal("");
  public fields: Field[] = [];
  public form: Item = {};
  public editing: Item | null = null;
  public actionEndpoint = "";
  public actionMethod = "POST";
  public wizard = signal(false);
  public step = 1;
  public furthestStep = 1;
  public wizardSteps = ['템플릿','기본 설정','서버 선택','도메인 연결','사전 점검'];
  private savedWizardSignature = '';
  private savedWizardDomain: Item | null = null;
  public source = "template";
  public selectedTemplate = "";
  public templatePage = 1;
  public templateHasMore = false;
  public templateFields = templateFields;
  public revealedInputs: Record<string, boolean> = {};
  public wizardDomainLoading = signal(false);
  public wizardDomainError = signal("");
  private wizardDomainsLoaded = false;
  public environment = signal<Item>({});
  public revealEnv = false;
  public environmentLoading = signal(false);
  public environmentError = signal('');
  private environmentSequence = 0;
  public composeLoading = signal(false);
  public composeLoadError = signal('');
  private composeSequence = 0;
  public serviceDomainLinks = signal<Item[]>([]);
  public serviceCompose = signal('');
  public serviceComposeLoading = signal(false);
  public serviceComposeError = signal('');
  private serviceComposeSequence = 0;
  public composeImageChanges = signal<Item[]>([]);
  private composeOriginal = '';
  public versionContent = signal<Item | null>(null);
  public versionLoading = signal(false);
  public versionCompare = false;
  public runtimeModalFullsize = false;
  public logsLoading = signal(false);
  private logsSequence = 0;
  public logsLoaded = false;
  @ViewChild('runtimeLogOutput') private runtimeLogOutput?:ElementRef<HTMLElement>;
  public healthDateFrom = '';
  public healthDateTo = '';
  public healthStatus = '';
  private appliedHealthFilter: {from:string;to:string;status:string} | null = null;
  public healthHistory = signal<Item[]>([]);
  public healthHistoryLoading = signal(false);
  public healthHistoryError = signal('');
  public healthOperation = signal<Item | null>(null);
  public serviceProbeSettings = signal<Item | null>(null);
  public healthPage = 1;
  public healthHasMore = false;
  private healthHistorySequence = 0;
  private healthOperationSequence = 0;
  private healthPolling = false;
  public containerId = containerId;
  public shortContainerId = shortContainerId;
  public runtimeState = runtimeState;
  public runtimeHealth = runtimeHealth;
  public runtimeImage = runtimeImage;
  public probeStatus = probeStatus;
  public availableServiceActions = computed(() => serviceActions(this.detail()));
  public canServiceAction(action: string): boolean { return this.availableServiceActions().has(action); }
  public get healthWorking(): boolean { return !!this.healthOperation() && !['succeeded','failed','canceled'].includes(this.healthOperation()!['status']); }
  public logSnapshot = signal("");
  public logLines = computed(() => containerLogLines(this.logSnapshot()));
  public showLogTimestamps = true;
  public readonly logRefreshInterval = 2500;
  public logComponent = "";
  public followLogs = false;
  public values: Item = {};
  public draft: Item = {
    name: "",
    compose: "",
    domain: "",
    zoneId: "",
    recordId: "",
    targetHost: "",
    targetPort: 80,
    serverId: "",
  };
  public savedDraft: Item | null = null;
  public preflight = signal<Item | null>(null);
  public date = date;
  public status = status;
  public tone = tone;
  public percent = percent;
  public bytes = bytes;
  public resourceTone = resourceTone;
  public dashboardRefresh = 0;
  public JSON = JSON;
  private returnFocus: HTMLElement | null = null;
  private subscription: any;
  private interval: any;
  private toastTimer: any;
  public terminalComponent = "";
  public migrationPreview = signal<Item | null>(null);
  public prunePreview = signal<Item | null>(null);
  public dnsRecords = signal<Item[]>([]);
  public get endpoint(): string {
    return (
      {
        servers: "/servers",
        services: "/services",
        templates: "/templates",
        macros: "/macros",
        schedules: "/schedules",
        reports: "/anomaly-reports/runs",
        operations: "/operations",
        domains: "/dns/zones",
      }[this.section] || ""
    );
  }
  public get submitLabel(): string {
    if (this.actionMethod === "DELETE") return this.section === "servers" ? "연결 해제" : "삭제하기";
    if (this.actionEndpoint === "/auth/password") return "비밀번호 변경";
    if (this.actionEndpoint.endsWith("/credentials")) return "SSH 키 교체";
    if (this.actionEndpoint.endsWith("/setup")) return "자동 구성 실행";
    if (this.actionEndpoint.endsWith("/repair")) return "실행 환경 복구";
    if (
      this.actionEndpoint.endsWith("/runs") &&
      this.actionEndpoint !== "/anomaly-reports/runs"
    )
      return "실행하기";
    if (this.actionEndpoint.endsWith("/test-mail")) return "테스트 메일 보내기";
    if (this.actionEndpoint.endsWith("/images/prune/preview"))
      return "정리할 이미지 확인";
    if (this.actionEndpoint === "/anomaly-reports/runs") return "리포트 생성";
    if (this.actionEndpoint.includes("/images/pull")) return "이미지 내려받기";
    if (this.actionEndpoint.includes("/images/import"))
      return "이미지 가져오기";
    if (this.actionEndpoint.includes("/migrations/plan"))
      return "이동 계획 확인";
    if (this.modal() === "confirm") return "실행하기";
    return ["PUT", "PATCH"].includes(this.actionMethod)
      ? "변경 저장"
      : "등록하기";
  }
  public get canCreate(): boolean {
    return (
      ["services", "servers", "templates", "macros", "schedules"].includes(
        this.section,
      ) && !this.id
    );
  }
  public get createLabel(): string {
    return (
      {
        services: "서비스 만들기",
        servers: "서버 연결",
        templates: "템플릿 만들기",
        macros: "매크로 만들기",
        schedules: "예약 추가",
      }[this.section] || "추가"
    );
  }
  public templateSummary = computed(() => templateConfiguration(this.detail()));
  public templateInputSummary = templateInputSummary;
  public get selectedTemplateObject(): Item | undefined {
    return this.templates().find((t) => t["id"] === this.selectedTemplate);
  }
  public get filtered(): Item[] {
    const s = this.search.toLowerCase().trim();
    const source = this.section === "images" ? this.imageGroups() : this.rows();
    return source
      .filter(
        (r) =>
          (!s ||
            [
              r["name"],
              r["title"],
              r["host"],
              r["type"],
              r["targetId"],
              r["message"],
              r["reference"],
              r["ref"],
              r["period"],
              r["content"],
              r["id"],
              this.section === "images" ? this.imageRef(r) : "",
            ].some((v) =>
              String(v || "")
                .toLowerCase()
                .includes(s),
            )) &&
          (this.section !== "domains" ||
            !this.dnsType ||
            r["type"] === this.dnsType) &&
          (!this.filter ||
            (this.section === "images"
              ? this.filter === "in-use"
                ? this.imageUsed(r)
                : this.filter === "protected"
                  ? r["protected"]
                  : !this.imageUsed(r)
              : (r["status"] || "") === this.filter)),
      )
      .sort((a, b) => this.section === "images" ? this.compareImages(a, b) : this.section === 'servers' ? compareServers(a, b, this.serverSort) : 0);
  }
  public serverSortChanged(): void {
    this.resetPage();
    saveServerSort(this.serverSort);
  }
  private compareImages(a: Item, b: Item): number {
    return this.imageSort === "size-desc"
      ? Number(b["size"] || 0) - Number(a["size"] || 0)
      : this.imageSort === "recent"
        ? String(b["lastUsed"] || "").localeCompare(String(a["lastUsed"] || ""))
        : this.imageRef(a).localeCompare(this.imageRef(b));
  }
  public get paged(): boolean {
    return (
      [
        "services",
        "templates",
        "macros",
        "schedules",
        "reports",
        "operations",
      ].includes(this.section) && !this.id
    );
  }
  public get displayed(): Item[] {
    return this.paged
      ? this.filtered
      : this.filtered.slice(
          (this.page - 1) * this.pageSize,
          this.page * this.pageSize,
        );
  }
  public get pages(): number {
    return Math.max(1, Math.ceil((this.paged ? this.total : this.filtered.length) / this.pageSize));
  }
  public get pageNumbers(): number[] {
    const total = this.pages;
    if (total <= 7) return Array.from({ length: total }, (_, index) => index + 1);
    if (this.page <= 4) return [1, 2, 3, 4, 5, 0, total];
    if (this.page >= total - 3) return [1, 0, total - 4, total - 3, total - 2, total - 1, total];
    return [1, 0, this.page - 1, this.page, this.page + 1, 0, total];
  }
  public count(key: string, sub = "total"): any {
    return this.summary()?.[key]?.[sub] ?? "—";
  }
  public serverName(id: string): string {
    return (
      this.servers().find((s) => s["id"] === id)?.["name"] || id || "미선택"
    );
  }
  public formatEndpoint(value: any): string {
    return value?.host ? value.host + ":" + (value.port || 22) : "—";
  }
  public async ngOnInit(): Promise<void> {
    this.section = this.router.url.split("/")[1].split("?")[0];
    if (this.section === "servers") this.serverSort = readServerSort();
    this.id = this.route.snapshot.paramMap.get("id") || "";
    const n = NAV.find((n) => n.id === this.section);
    this.title = n?.title || "워크스페이스";
    this.broadcastContext();
    this.icon = n?.icon || "cube";
    this.description = DESCRIPTIONS[this.section] || "";
    this.dateTo = new Intl.DateTimeFormat("sv-SE", {
      timeZone: "Asia/Seoul",
    }).format(new Date());
    this.dateFrom = new Intl.DateTimeFormat("sv-SE", {
      timeZone: "Asia/Seoul",
    }).format(new Date(Date.now() - (this.section === 'servers' ? 168 : 24) * 3600000));
    if (this.section === "system") this.systemSubscription = this.route.queryParamMap.subscribe(params => {
      const tab = params.get("tab");
      this.systemTab.set(this.systemTabs.some(item => item.id === tab) ? tab! : "general");
    });
    await this.load();
    this.subscription = this.route.paramMap.subscribe((params) => {
      const next = params.get("id") || "";
      if (next !== this.id) {
        this.environmentSequence++;this.composeSequence++;this.serviceComposeSequence++;this.serviceCompose.set('');this.healthHistorySequence++;this.healthOperationSequence++;
        this.environment.set({});this.revealEnv=false;this.modal.set('');this.form={};this.serviceDomainLinks.set([]);this.healthOperation.set(null);
        this.id = next;
        this.tab = "overview";
        this.detail.set(null);
        void this.load();
      }
    });
    this.interval = setInterval(() => {
      if (this.section === "domains") this.dnsSyncNow.set(Date.now());
      if (this.section === "operations" || this.operation())
        void this.pollOperation();
      if (this.modal() === "container-logs" && this.followLogs && !this.logsLoading()) void this.loadLogs(true);
      if (this.agentMaintenance()) void this.pollMaintenance();
      if (this.healthWorking) void this.pollServiceHealth();
      if (
        this.tab === "ai-audit" &&
        ["analyzing", "optimizing"].includes(this.serverAudit()?.["status"])
      )
        void this.loadAudit(true);
    }, this.logRefreshInterval);
    if (this.route.snapshot.queryParamMap.get("create") === "true")
      this.openCreate();
    if (
      this.section === "reports" &&
      this.route.snapshot.queryParamMap.get("reportId")
    ) {
      try {
        this.open(
          await wiz.api.get<Item>(
            "/anomaly-reports/runs/" +
              encodeURIComponent(
                this.route.snapshot.queryParamMap.get("reportId")!,
              ),
          ),
        );
      } catch (e) {
        this.error.set(errorMessage(e));
      }
    }
  }
  public ngOnDestroy(): void {
    this.environmentSequence++;this.composeSequence++;this.serviceComposeSequence++;this.serviceCompose.set('');this.healthHistorySequence++;this.healthOperationSequence++;
    this.resetMacroDialog();
    this.macroExecutionSequence++; clearTimeout(this.macroExecutionPoll);
    clearTimeout(this.apacheTemplatePoll);this.apacheTemplateRequest++;
    this.headerObserver?.disconnect();
    this.headerRegistration.destroy();
    clearTimeout(this.schedulePreviewTimer);
    this.schedulePreviewSequence++;
    this.feedbackObserver?.disconnect();
    this.refreshRegistration.destroy();
    if (this.pageRefresh.current() === this.refreshAction) this.pageRefresh.current.set(null);
    clearInterval(this.interval);
    clearTimeout(this.toastTimer);
    this.subscription?.unsubscribe();
    this.systemSubscription?.unsubscribe();
  }
  public async load(): Promise<void> {
    this.loading.set(true);
    this.error.set("");
    try {
      if (this.section === "dashboard") {
        this.dashboardRefresh++;
      } else if (this.section === "system") {
        const [settings, appearance, health, runtime, smtp, dnsTargets] = await Promise.all([
          wiz.api.get<Item>("/system/settings"),
          wiz.api.get<Item>("/system/appearance"),
          wiz.api.get<Item>("/system/health"),
          wiz.api.get<Item>("/system/runtime"),
          wiz.api.get<Item>("/anomaly-reports/settings"),
          wiz.api.get<Item>("/system/dns-targets"),
        ]);
        this.settings.set(settings);
        this.dnsAddressesText = (dnsTargets.addresses || []).join("\n");
        this.dnsDefaultAddress = dnsTargets.defaultAddress || "";
        this.smtp.set({ ...smtp, smtpPassword: "" });
        this.appearance.set(appearance);
        this.health.set({ ...health, ...runtime });
        await this.refreshAgentStatus();
        this.agentMaintenance.set((await wiz.api.get<Item | null>("/agent/maintenance/current")) ?? null);
      } else if (this.section === "images") {
        this.servers.set(serverChoices(items(await wiz.api.get("/servers"))));
        const wanted =
          this.selectedServer ||
          this.route.snapshot.queryParamMap.get("serverId");
        this.selectedServer =
          this.servers().find((s) => s["id"] === wanted)?.["id"] ||
          this.servers().find((s) => s["executionMode"] === "local")?.["id"] ||
          this.servers()[0]?.["id"] ||
          "";
        await this.loadImages();
      } else if (this.section === "domains") {
        this.zones.set(items(await wiz.api.get("/dns/zones")));
        this.selectedZone =
          this.zones().find((z) => z["id"] === this.selectedZone)?.["id"] ||
          this.zones()[0]?.["id"] ||
          "";
        await this.loadRecords();
      } else if (this.id) {
        this.detail.set(await wiz.api.get<Item>(this.endpoint + "/" + this.id));
        this.operationEventsRemaining = this.section === "operations" && (this.detail()?.["events"]?.length ?? 0) >= 1000;
        if (["servers", "services", "macros"].includes(this.section)) {
          this.servers.set(serverChoices(items(await wiz.api.get("/servers"))));
          if (this.section === "servers") {
            this.selectedServer = this.id;
            const setup = this.detail()?.["setupOperation"] ?? null;
            this.serverSetupOperation.set(setup);
            if (setup && !["succeeded", "failed", "canceled"].includes(setup["status"])) this.operation.set(setup);
            const disconnect = this.detail()?.["disconnectOperation"] ?? null;
            this.serverDisconnectOperation.set(disconnect);
            if (disconnect && !["succeeded", "failed", "canceled"].includes(disconnect["status"])) this.operation.set(disconnect);
            await this.loadResources();
          }
        }
      } else {
        if (this.paged) {
          const listPage = () => wiz.api.getPage<Item>(
            this.endpoint + "?page=" + this.page + "&size=" + this.pageSize + this.operationQuery + this.reportQuery,
          );
          let response = await listPage();
          this.total = response.total;
          if (this.page > this.pages) {
            this.page = this.pages;
            response = await listPage();
            this.total = response.total;
          }
          this.rows.set(response.items);
        } else {
          this.rows.set(items(await wiz.api.get(this.endpoint)));
          this.total = this.rows().length;
          this.page = Math.min(this.page, this.pages);
        }
        if (["services", "schedules", "macros", "operations"].includes(this.section))
          this.servers.set(serverChoices(items(await wiz.api.get("/servers"))));
      }
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.loading.set(false);
      this.broadcastContext();
    }
  }
  private recordLoadSequence = 0;
  public dnsSyncPreview = signal<Item | null>(null);
  public dnsSyncLoading = signal(false);
  private syncPreviewSequence = 0;
  public dnsSyncNow = signal(Date.now());
  public get lastDnsSync(): ReturnType<typeof dnsSyncTime> {
    return dnsSyncTime(this.zones().find(zone => zone["id"] === this.selectedZone)?.["lastSyncAt"], this.dnsSyncNow());
  }
  public chooseZone(id: string): void { if (this.selectedZone !== id) { this.selectedZone = id; void this.loadRecords(); } }
  public async loadRecords(): Promise<void> {
    const sequence = ++this.recordLoadSequence, zone = this.selectedZone;
    this.loading.set(true); this.error.set("");
    try {
      const records: Item[] = [];
      if (zone) for (let page = 1; page <= 200; page++) {
        const batch = items(await wiz.api.get("/dns/zones/" + zone + "/records?page=" + page + "&size=100"));
        if (sequence !== this.recordLoadSequence || zone !== this.selectedZone) return;
        records.push(...batch);
        if (batch.length < 100) break;
      }
      if (sequence === this.recordLoadSequence) { this.rows.set(records); this.page = 1; }
    } catch (e) { if (sequence === this.recordLoadSequence) this.error.set(errorMessage(e)); }
    finally { if (sequence === this.recordLoadSequence) this.loading.set(false); }
  }
  public async loadImages(quiet = false): Promise<void> {
    const sequence = ++this.imageLoadSequence;
    const serverId = this.selectedServer;
    if (!quiet) this.loading.set(true);
    this.imageRefreshing.set(true);
    this.selectedImages.set(new Set());
    this.error.set("");
    try {
      if (!serverId) { this.rows.set([]); return; }
      const data = await wiz.api.get<Item>("/servers/" + serverId + "/images");
      if (sequence !== this.imageLoadSequence || serverId !== this.selectedServer) return;
      if (data["error"]) throw new Error(data["error"]);
      this.rows.set(items(data));
      this.selectedImages.set(new Set());
      this.page = Math.min(this.page, this.pages);
    } catch (e) {
      if (sequence === this.imageLoadSequence) {
        if (!quiet) this.rows.set([]);
        this.error.set(errorMessage(e));
      }
    } finally {
      if (sequence === this.imageLoadSequence) {
        this.loading.set(false);
        this.imageRefreshing.set(false);
      }
    }
  }
  public async loadResources(): Promise<void> {
    const request = ++this.resourceRequest;
    const serverId = this.selectedServer;
    this.resourcesLoading.set(true);
    try {
      const range = this.resourceRange(true);
      const data = items(await wiz.api.get('/dashboard/resources?from=' + encodeURIComponent(range.from) +
        '&to=' + encodeURIComponent(range.to) + (serverId ? '&serverId=' + serverId : '')));
      if (request !== this.resourceRequest || serverId !== this.selectedServer) return;
      this.resources.set(data);
      this.resourceWindow.set(range);
      this.error.set('');
    } catch (e) {
      if (request === this.resourceRequest) this.error.set(errorMessage(e));
    } finally {
      if (request === this.resourceRequest) this.resourcesLoading.set(false);
    }
  }
  public async setResourcePeriod(hours:number): Promise<void> {
    this.resourcePeriod = hours;
    const format = new Intl.DateTimeFormat('sv-SE', {timeZone:'Asia/Seoul'});
    this.dateFrom = format.format(new Date(Date.now() - hours * 3600000));
    this.dateTo = format.format(new Date());
    await this.loadResources();
  }
  private resourceRange(refresh=false): {from:string;to:string} {
    if (this.section === 'servers' && this.resourcePeriod) {
      if (!refresh && this.resourceWindow()) return this.resourceWindow()!;
      const to = new Date();
      return {from:new Date(to.getTime() - this.resourcePeriod * 3600000).toISOString(),to:to.toISOString()};
    }
    if (!this.dateFrom || !this.dateTo || this.dateFrom > this.dateTo)
      throw new Error('조회 시작일과 종료일을 확인해 주세요.');
    // Date queries include the entire final day with an exclusive upper bound.
    return {from:this.dateFrom+'T00:00:00+09:00',to:new Date(Date.parse(this.dateTo+'T00:00:00+09:00')+86400000).toISOString()};
  }
  public openServerConfiguration(): void {
    this.serverConfigurationTrigger = document.activeElement as HTMLElement;
    this.serverConfigurationError.set('');
    this.serverConfigurationOpen.set(true);
    setTimeout(() => document.querySelector<HTMLElement>('.server-configuration-dialog button:not(:disabled)')?.focus(), 0);
  }
  public closeServerConfiguration(): void {
    if (this.busy() || this.modal()) return;
    this.serverConfigurationOpen.set(false);
    this.serverConfigurationError.set('');
    setTimeout(() => this.serverConfigurationTrigger?.focus(), 0);
  }
  public serverConfigurationKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      this.closeServerConfiguration();
    } else this.escape(event);
  }
  public apacheTemplateContent = '';
  public apacheTemplatePrompt = '';
  public apacheTemplateAssist = false;
  public apacheTemplateJob = signal<Item | null>(null);
  public apacheTemplateError = signal('');
  public apacheTemplateBusy = signal(false);
  private apacheTemplatePoll: any;
  private apacheTemplateRequest = 0;
  public readonly templateSections = [
    { id: 'overview', label: '기본 정보', icon: 'help' },
    { id: 'template-inputs', label: '입력 설정', icon: 'settings' },
    { id: 'compose', label: 'Docker Compose', icon: 'cube' },
    { id: 'template-apache', label: 'Apache2', icon: 'globe' },
  ];
  public templateEditorTab = 'overview';
  public templateDraft: Item = {};
  public templateEditorExisting = false;
  private templateEditorSource: Item | null = null;
  private templateEditorInitial: Item = {};
  public instructionIndex(index: number): number { return index; }
  public openTemplateEditor(source: Item | null = null, clone = false): void {
    this.templateInputSelectedIndex = 0;
    this.templateEditorSource = source;
    this.templateEditorExisting = !!source && !clone;
    this.templateEditorTab = this.templateEditorExisting && this.templateSections.some(s => s.id === this.tab) ? this.tab : 'overview';
    this.templateDraft = {
      id: source ? source.id + (clone ? '-copy' : '') : '',
      name: source ? source.name + (clone ? ' 복사' : '') : '',
      description: source?.description || '', enabled: source?.enabled ?? true,
      tags: (source?.tags || []).join(', '), instructions: [...(source?.instructions || [])],
      inputs: structuredClone(source?.inputs || []),
      compose: source?.compose || 'services:\n  app:\n    image: nginx:alpine\n',
      endpointService: source?.publicEndpoint?.service || '', endpointPort: source?.publicEndpoint?.port ?? null,
    };
    clearTimeout(this.apacheTemplatePoll);this.apacheTemplateRequest++;
    this.apacheTemplateBusy.set(false);this.apacheTemplateJob.set(null);this.apacheTemplateError.set('');
    this.apacheTemplateContent = source?.apache || '';
    this.apacheTemplatePrompt = '';this.apacheTemplateAssist = false;
    this.templateEditorInitial = this.templateEditorValues();
    this.openModal('template-editor', clone ? '템플릿 복제' : source ? '템플릿 수정' : '템플릿 만들기',
      '항목별로 내용을 편집하고 한 번에 저장합니다. 저장한 설정은 새 서비스에 적용됩니다.', []);
  }
  private templateEditorValues(): Item {
    const d = this.templateDraft;
    const endpoint = d.endpointService.trim() ? { ...(this.templateEditorSource?.publicEndpoint || {}), service: d.endpointService.trim(), port: d.endpointPort === null || d.endpointPort === '' ? null : Number(d.endpointPort) } : null;
    return { id: d.id.trim(), name: d.name.trim(), description: d.description, enabled: d.enabled,
      tags: d.tags.split(',').map((tag: string) => tag.trim()).filter(Boolean), instructions: [...d.instructions],
      inputs: structuredClone(d.inputs), compose: d.compose, publicEndpoint: endpoint, apache: this.apacheTemplateContent };
  }
  public async saveTemplateEditor(): Promise<void> {
    if (this.busy() || this.apacheTemplateBusy()) return;
    this.modalError.set('');
    const values = this.templateEditorValues();
    if (!/^[a-z0-9][a-z0-9-]{0,79}$/.test(values.id) || !values.name || values.name.length > 120) {
      this.templateEditorTab = 'overview';this.modalError.set('ID는 영문 소문자·숫자·하이픈으로 80자 이내, 이름은 1~120자로 입력하세요.');return;
    }
    if (values.publicEndpoint && (!Number.isInteger(values.publicEndpoint.port) || values.publicEndpoint.port < 1 || values.publicEndpoint.port > 65535)) {
      this.templateEditorTab = 'compose';this.modalError.set('기본 연결의 내부 포트는 1~65535 정수로 입력하세요.');return;
    }
    const inputError = inputDefinitionError(values.inputs, values.compose);
    if (inputError) {
      this.templateEditorTab = 'template-inputs';this.templateInputSelectedIndex = inputError.index;this.modalError.set(inputError.message);return;
    }
    const changes: Item = {};
    for (const [key, value] of Object.entries(values)) {
      if (!this.templateEditorSource || JSON.stringify(value) !== JSON.stringify(this.templateEditorInitial[key]) || (!this.templateEditorExisting && ['id','name'].includes(key))) changes[key] = value;
    }
    if (!this.templateEditorSource && !changes.apache) delete changes.apache;
    const payload = { document: this.templateEditorSource?.document ?? null, changes };
    this.busy.set(true);
    try {
      const endpoint = this.templateEditorExisting ? '/templates/' + this.templateEditorSource!.id + '/editor' : '/templates/editor';
      const saved = await wiz.api.request<Item>(this.templateEditorExisting ? 'PUT' : 'POST', endpoint, payload);
      const selected = this.templateEditorTab;
      this.modal.set('');this.templateDraft = {};
      if (this.id === saved.id) this.detail.set(saved);
      else await this.router.navigateByUrl('/templates/' + saved.id);
      this.tab = selected;this.broadcastContext();
      this.notify('템플릿을 저장했습니다.');
      setTimeout(() => this.returnFocus?.focus(), 0);
    } catch (error) {
      const message = errorMessage(error);this.modalError.set(message);
      if (message.startsWith('Apache2')) this.templateEditorTab = 'template-apache';
      else {
        const index = this.templateDraft.inputs.findIndex((input:Item) => message.startsWith((input.label || input.key)+':'));
        if (index >= 0) {this.templateEditorTab='template-inputs';this.templateInputSelectedIndex=index;}
      }
    }
    finally { this.busy.set(false); }
  }
  public async assistTemplateApache(): Promise<void> {
    if(this.apacheTemplateBusy())return;
    if(!this.apacheTemplatePrompt.trim()){this.apacheTemplateError.set('AI에 요청할 내용을 입력하세요.');return;}
    this.apacheTemplateBusy.set(true);this.apacheTemplateError.set('');
    const request=++this.apacheTemplateRequest;
    try{
      const job=await wiz.api.post<Item>('/agent/apache-assist',{fileName:'template-'+this.templateDraft.id+'.conf',content:this.apacheTemplateContent,prompt:this.apacheTemplatePrompt+'\n서비스 템플릿의 재사용 가능한 HTTP VirtualHost 하나를 작성하세요. ServerName {{ domain }}, upstream http://{{ target_host }}:{{ target_port }}/ 변수를 반드시 유지하세요. ProxyRequests Off, ProxyPass와 ProxyPassReverse가 필요합니다. HTTPS/인증서 경로는 서버가 자동 구성하므로 넣지 마세요. Include, Rewrite, 외부 경로, shell은 사용하지 마세요.'});
      if(request!==this.apacheTemplateRequest)return;this.apacheTemplateJob.set(job);this.pollTemplateApache(job.id,request);
    }catch(error){this.apacheTemplateError.set(errorMessage(error));this.apacheTemplateBusy.set(false);}
  }
  private pollTemplateApache(id: string,request: number): void {
    this.apacheTemplatePoll=setTimeout(async()=>{
      if(request!==this.apacheTemplateRequest)return;
      try{
        const job=await wiz.api.get<Item>('/agent/jobs/'+id);
        if(request!==this.apacheTemplateRequest)return;this.apacheTemplateJob.set(job);
        if(['succeeded','failed','canceled'].includes(job.status)){
          this.apacheTemplateBusy.set(false);
          if(job.status!=='succeeded'){this.apacheTemplateError.set('AI 작성을 완료하지 못했습니다. 기존 설정은 유지됩니다.');return;}
          const message=[...(job.messages||[])].reverse().find((m:Item)=>m.role==='assistant');
          const text=String(message?.text||''),start=text.indexOf('{');
          const result=JSON.parse(start>=0?text.slice(start):text);
          if(typeof result.templateDocument!=='string'||!result.templateDocument.trim())throw Error('AI 응답에 Apache 설정이 없습니다.');
          this.apacheTemplateContent=result.templateDocument;
          this.apacheTemplateError.set('AI 작성 결과를 편집기에 반영했습니다. 내용을 확인한 후 저장하세요.');return;
        }
        this.pollTemplateApache(id,request);
      }catch(error){if(request===this.apacheTemplateRequest){this.apacheTemplateBusy.set(false);this.apacheTemplateError.set(errorMessage(error));}}
    },1000);
  }
  public async selectTab(tab: string): Promise<void> {
    this.tab = tab;
    this.broadcastContext();
    this.error.set("");
    if (tab !== "environment") {
      this.environmentSequence++;this.environmentLoading.set(false);this.environmentError.set('');
      this.environment.set({});
      this.revealEnv = false;
    }
    if(tab !== 'compose'){this.serviceComposeSequence++;this.serviceCompose.set('');this.serviceComposeLoading.set(false);this.serviceComposeError.set('');}
    if(this.section==='services' && tab==='compose')await this.loadServiceCompose();
    if(tab!=='service-health'){this.healthHistorySequence++;this.healthHistoryLoading.set(false);}
    if(this.section==='services' && tab==='service-health'){if(!this.healthDateFrom){this.healthDateFrom=this.dateFrom;this.healthDateTo=this.dateTo;}await this.loadServiceHealth();}
    if (this.section === "services" && tab === "environment")
      await this.loadEnvironment();
    if (this.section === "macros" && tab === "files") await this.macroFiles();
    if (this.section === "servers" && tab === "ai-audit")
      await this.loadAudit(true);
    if (this.section === "services" && this.id) {
      try {
        if (tab === "apache")
          this.extra.set(
            items(await wiz.api.get("/services/" + this.id + "/apache")),
          );
        if (tab === "versions")
          this.extra.set(
            items(await wiz.api.get("/services/" + this.id + "/versions")),
          );
        if (tab === "runtime") {
          const runtime = items(
            await wiz.api.get("/services/" + this.id + "/runtime"),
          );
          this.detail.update((d) => ({ ...d, runtime }));
        }
      } catch (e) {
        this.error.set(errorMessage(e));
      }
    }
  }
  public async loadAudit(silent = false): Promise<void> {
    if (!this.id) return;
    try {
      this.serverAudit.set(
        await wiz.api.get<Item>("/servers/" + this.id + "/audits/latest"),
      );
    } catch (e) {
      if (!silent) this.error.set(errorMessage(e));
      else this.serverAudit.set(null);
    }
  }
  public async startAudit(): Promise<void> {
    if (this.busy()) return;
    this.busy.set(true);
    this.error.set("");
    this.selectedAudit.set(new Set());
    try {
      this.serverAudit.set(
        await wiz.api.post<Item>("/servers/" + this.id + "/audits", {}),
      );
      this.notify("읽기 전용 수집을 마치고 AI 종합 분석을 시작했습니다.");
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public toggleAudit(code: string): void {
    const next = new Set(this.selectedAudit());
    next.has(code) ? next.delete(code) : next.add(code);
    this.selectedAudit.set(next);
  }
  public confirmOptimizeAudit(): void {
    const audit = this.serverAudit();
    if (!audit || !this.selectedAudit().size) return;
    this.confirmAction(
      "선택한 서버 최적화 실행",
      this.selectedAudit().size +
        "개 항목을 서버에서 순서대로 실행합니다. AI가 임의 명령을 실행하지 않으며 사전 정의된 작업만 허용됩니다.",
      "/servers/" + this.id + "/audits/" + audit["id"] + "/optimize",
      { codes: [...this.selectedAudit()] },
    );
  }
  public async optimizeAudit(): Promise<void> {
    const audit = this.serverAudit();
    if (!audit || !this.selectedAudit().size || this.busy()) return;
    this.busy.set(true);
    this.error.set("");
    try {
      const op = await wiz.api.post<Item>(
        "/servers/" + this.id + "/audits/" + audit["id"] + "/optimize",
        { codes: [...this.selectedAudit()] },
      );
      this.operation.set(op);
      this.serverAudit.set({ ...audit, status: "optimizing" });
      this.notify("선택한 최적화 작업을 접수했습니다.");
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public auditTone(value: string): string {
    return value === "high"
      ? "danger"
      : value === "medium"
        ? "warning"
        : "info";
  }
  public notify(message: string, tone: 'success' | 'error' | 'warn' = 'success'): void {
    this.noticeTone.set(tone);
    this.notice.set(message);
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(() => this.notice.set(""), 6000);
  }
  public resetPage(): void {
    if (!this.paged) this.page = 1;
  }
  public filterChanged(): void {
    this.page = 1;
    if (this.paged) void this.load();
  }
  public goToPage(page: number): void {
    if (this.loading() || !Number.isInteger(page) || page < 1 || page > this.pages || page === this.page) return;
    this.page = page;
    if (this.paged) void this.load();
  }
  public open(row: Item): void {
    if (
      ["servers", "services", "templates", "macros", "operations"].includes(
        this.section,
      )
    )
      void this.router.navigateByUrl("/" + this.section + "/" + row["id"]);
    else if (this.section === "schedules") this.openEdit(row);
    else if (this.section === "reports") {
      this.editing = row;
      this.modalTitle = "운영 리포트";
      this.modalDescription = date(row["createdAt"]);
      this.modal.set("report");
      void this.loadReportDocument(String(row["id"]));
    } else if (this.section === "domains") this.openRecord(row);
  }
  private async loadReportDocument(id: string): Promise<void> {
    const sequence = ++this.reportDocumentSequence;
    this.reportDocument.set(null);
    this.reportDocumentError.set("");
    try {
      const document = await wiz.api.get<string>("/anomaly-reports/runs/" + encodeURIComponent(id) + "/document");
      if (sequence !== this.reportDocumentSequence || this.modal() !== "report") return;
      // Only the authenticated, server-escaped report document enters a scriptless sandbox.
      this.reportDocument.set(this.sanitizer.bypassSecurityTrustHtml(document));
    } catch (error) {
      if (sequence === this.reportDocumentSequence && this.modal() === "report")
        this.reportDocumentError.set(errorMessage(error));
    }
  }
  public openModal(
    kind: string,
    title: string,
    description: string,
    fields: Field[],
    form: Item = {},
    endpoint = "",
    method = "POST",
  ): void {
    this.resetMacroDialog();
    this.returnFocus = document.activeElement as HTMLElement;
    this.broadcastContext();
    this.imageTransferMode = "";
    this.pruneMode = "unused";
    this.runtimeModalFullsize = false;
    this.modal.set(kind);
    this.modalTitle = title;
    this.modalDescription = description;
    this.fields = fields;
    this.form = { ...form };
    this.modalError.set("");
    this.actionEndpoint = endpoint;
    this.actionMethod = method;
    setTimeout(
      () =>
        (
          document.querySelector<HTMLElement>(
            ".console-action-dialog input,.console-action-dialog textarea,.console-action-dialog select",
          ) || document.querySelector<HTMLElement>(".console-action-dialog button:not(:disabled)")
        )?.focus(),
      0,
    );
  }
  public openCreate(): void {
    this.editing = null;
    if (this.section === "services") {
      void this.openWizard();
      return;
    }
    if (this.section === "servers") {
      this.openModal(
        "form",
        "서버 연결",
        "패스워드로 최초 연결하면 전용 개인키를 자동 발급·등록하고 이후 키로 접속합니다. 필수 도구·Docker·실행기·수집기를 SSH로 자동 구성하고 작업 종료 후 패스워드를 폐기합니다.",
        this.serverFields(),
        {
          port: 22,
          username: "",
          authenticationMethod: "password",
        },
        "/servers",
      );
    }
    if (this.section === "templates") this.openTemplateEditor();
    if (this.section === "macros") void this.openMacroEditor();
    if (this.section === "schedules") this.openSchedule();
  }
  public serverFields(edit = false): Field[] {
    return [
      { key: "name", label: "표시 이름", required: true },
      { key: "host", label: "호스트 주소", required: true },
      { key: "port", label: "SSH 포트", type: "number", required: true },
      { key: "username", label: "SSH 사용자", required: true, hint: edit ? "" : "자동 구성을 위해 root 또는 sudo 설치 권한이 필요합니다." },
      ...(!edit
        ? [
            {
              key: "authenticationMethod",
              label: "등록 인증 방식",
              type: "select",
              required: true,
              options: [
                { value: "password", label: "패스워드 · 개인키 자동 발급" },
                { value: "privateKey", label: "기존 개인키 사용" },
              ],
            },
            {
              key: "password",
              label: "SSH 패스워드",
              type: "password",
              required: true,
              hint: "SSH 연결과 sudo 초기 구성에 사용합니다. 구성 작업 종료 후 패스워드를 폐기합니다.",
            },
            {
              key: "fingerprint",
              label: "확인한 SSH 호스트 지문",
              required: true,
              hint: "지문을 조회하고 서버 관리자가 제공한 SHA256 지문과 대조하세요.",
            },
          ]
        : []),
      {
        key: "privateKey",
        label: edit ? "새 SSH 개인키 (교체 시)" : "SSH 개인키",
        type: "file",
        required: !edit,
        hint: "OpenSSH 개인키 파일. 원문은 다시 표시하지 않습니다.",
      },
      ...(!edit ? [{ key: "sudoPassword", label: "초기 구성용 sudo 패스워드 (선택)", type: "password", hint: "root 또는 비밀번호 없는 sudo 계정은 비워두세요." }] : []),
      { key: "passphrase", label: "개인키 암호 (선택)", type: "password" },
      {
        key: "certificate",
        label: "OpenSSH 사용자 인증서 (선택)",
        type: "file",
      },
    ];
  }
  public fieldKey(index: number, field: Field): string {
    return field.key;
  }
  public optionKey(index: number, option: any): string {
    return option.value;
  }
  public get isDnsRecordForm(): boolean {
    return this.section === "domains" && this.modal() === "form" && this.actionEndpoint.startsWith("/dns/") && this.actionEndpoint.includes("/records");
  }
  public get isDnsZoneEditForm(): boolean {
    return this.section === "domains" && this.modal() === "form" && this.actionMethod === "PUT" && /^\/dns\/zones\/[^/]+$/.test(this.actionEndpoint);
  }
  public get serverOptions(): Item[] { return serverChoices(this.servers()); }
  public get visibleFields(): Field[] {
    if (this.isMacroRun) return macroRunFields(this.serverOptions, this.macroServices(), this.macroContainers(), this.form, this.macroTargetsLoading());
    if (this.isDnsRecordForm) return dnsRecordFields(this.zones(), this.form, !!this.editing);

    let fields = this.fields;
    if (this.actionEndpoint === "/servers") {
      const password = this.form["authenticationMethod"] === "password";
      fields = fields.filter((field) =>
        password
          ? !["privateKey", "passphrase", "certificate", "sudoPassword"].includes(field.key)
          : field.key !== "password",
      );
    }
    if (this.actionEndpoint.startsWith("/schedules")) {
      const job = this.form["jobType"];
      fields = fields.filter((f) =>
        f.key === "targetId"
          ? ["macro-run", "service-health", "local-image-prune", "dns-sync"].includes(job)
          : f.key === "scheduleServerId" || f.key === "argsJson"
            ? job === "macro-run"
            : ["minimumAgeHours", "dryRun"].includes(f.key)
              ? job === "local-image-prune"
              : f.key === "pruneConfirmed"
                ? job === "local-image-prune" && !this.form["dryRun"]
                : true,
      );
      fields = fields.map((f) =>
        f.key === "targetId"
          ? {
              ...f,
              label:
                job === "macro-run"
                  ? "실행할 매크로"
                  : job === "local-image-prune"
                    ? "이미지를 정리할 서버"
                    : job === "dns-sync" ? "동기화할 DNS 영역" : "점검할 서비스 (미선택 시 전체)",
              type: "select",
              required: job !== "service-health",
              options: (job === "macro-run"
                ? this.scheduleMacros
                : job === "local-image-prune"
                  ? this.servers()
                  : job === "dns-sync" ? this.zones() : this.scheduleServices
              ).map((r) => ({ value: r["id"], label: r["name"] })),
            }
          : f,
      );
    }
    return fields;
  }
  private scheduleMacros: Item[] = [];
  private scheduleServices: Item[] = [];
  public scheduleUpdating = signal(new Set<string>());
  public schedulePreview = signal("");
  public schedulePreviewError = signal("");
  public schedulePreviewPending = signal(false);
  private schedulePreviewTimer?: ReturnType<typeof setTimeout>;
  private schedulePreviewSequence = 0;
  public previewSchedule(): void {
    clearTimeout(this.schedulePreviewTimer);
    const sequence = ++this.schedulePreviewSequence;
    this.schedulePreview.set("");
    this.schedulePreviewError.set("");
    const cron = String(this.form["cron"] || "").trim();
    this.schedulePreviewPending.set(!!cron);
    if (!cron) return;
    this.schedulePreviewTimer = setTimeout(async () => {
      try {
        const result = await wiz.api.get<Item>("/schedules/preview?cron=" + encodeURIComponent(cron));
        if (sequence === this.schedulePreviewSequence) this.schedulePreview.set(date(result["nextFireAt"]));
      } catch (error) {
        if (sequence === this.schedulePreviewSequence) this.schedulePreviewError.set(errorMessage(error));
      } finally {
        if (sequence === this.schedulePreviewSequence) this.schedulePreviewPending.set(false);
      }
    }, 300);
  }
  public async toggleSchedule(row: Item, event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const enabled = input.checked;
    input.checked = !!row["enabled"];
    const id = String(row["id"]);
    if (this.scheduleUpdating().has(id)) return;
    this.scheduleUpdating.update(ids => new Set(ids).add(id));
    this.error.set("");
    try {
      const updated = await wiz.api.patch<Item>("/schedules/" + id + "/enabled", { enabled });
      if (this.section === "schedules") this.rows.update(rows => rows.map(item => item["id"] === id ? updated : item));
      this.notify(String(row["name"]) + (enabled ? " 예약을 활성화했습니다." : " 예약을 비활성화했습니다."));
    } catch (error) {
      this.error.set(errorMessage(error));
    } finally {
      this.scheduleUpdating.update(ids => { const next = new Set(ids); next.delete(id); return next; });
    }
  }
  private async allChoices(endpoint: string): Promise<Item[]> {
    const result: Item[] = [];
    for (let page = 1; page <= 100; page++) {
      const rows = items(
        await wiz.api.get(endpoint + "?page=" + page + "&size=100"),
      );
      result.push(...rows);
      if (rows.length < 100) break;
    }
    return result;
  }
  public async discoverNewFingerprint(): Promise<void> {
    this.busy.set(true);
    this.modalError.set("");
    try {
      const result = await wiz.api.post<Item>("/servers/fingerprint/discover", {
        host: this.form["host"],
        port: Number(this.form["port"] || 22),
      });
      this.form["fingerprint"] = result["fingerprint"];
    } catch (error) {
      this.modalError.set(errorMessage(error));
    } finally {
      this.busy.set(false);
    }
  }

  public macroFields(): Field[] {
    return [
      { key: "name", label: "매크로 이름", required: true },
      { key: "description", label: "설명" },
      {
        key: "script",
        label: "Shell 스크립트",
        type: "textarea",
        required: true,
        rows: 12,
      },
    ];
  }
  public async openSchedule(row?: Item): Promise<void> {
    this.busy.set(true);
    let reportTypes: string[] = [];
    try {
      const [servers, macros, services, availableReports, zones] = await Promise.all([
        wiz.api.get("/servers"),
        this.allChoices("/macros"),
        this.allChoices("/services"),
        wiz.api.get<string[]>("/schedules/report-types"),
        this.allChoices("/dns/zones"),
      ]);
      reportTypes = availableReports;
      this.servers.set(serverChoices(items(servers)));
      this.scheduleMacros = macros;
      this.scheduleServices = services;
      this.zones.set(zones);
    } catch (e) {
      this.error.set(errorMessage(e));
      return;
    } finally {
      this.busy.set(false);
    }
    this.editing = row || null;
    this.openModal(
      "form",
      row ? "예약 작업 수정" : "예약 작업 추가",
      "DNS 동기화는 Cloudflare → 로컬로 반영합니다. 일간 리포트 전에 실행하도록 기본 오전 3시 50분을 제안합니다. 리포트에는 서비스 상태와 인증서 점검도 포함됩니다.",
      [
        { key: "name", label: "예약 이름", required: true },
        {
          key: "jobType",
          label: "작업 종류",
          type: "select",
          required: true,
          options: [
            { value: "local-image-prune", label: "미사용 이미지 정리" },
            { value: "macro-run", label: "매크로 실행" },
            { value: "dns-sync", label: "DNS 동기화" },
            { value: "anomaly-daily", label: "일간 리포트" },
            { value: "anomaly-weekly", label: "주간 리포트" },
            { value: "anomaly-monthly", label: "월간 리포트" },
            ...(row && ["service-health", "certificate-renewal-check"].includes(row["jobType"])
              ? [{ value: row["jobType"], label: this.jobLabel(row["jobType"]) }] : []),
          ].filter(option => !option.value.startsWith("anomaly-") || reportTypes.includes(option.value) || option.value === row?.["jobType"]),
        },
        {
          key: "cron",
          label: "실행 주기 (Quartz cron)",
          required: true,
          hint: "예: 0 0 9 * * ? → 매일 오전 9시",
        },
        {
          key: "targetId",
          label: "대상 ID",
        },
        {
          key: "scheduleServerId",
          label: "매크로를 실행할 서버 (매크로 작업만)",
          type: "select",
          options: this.serverOptions.map((s) => ({
            value: s["id"],
            label: s["name"],
          })),
        },
        {
          key: "argsJson",
          label: "매크로 실행 옵션 (JSON)",
          type: "textarea",
          rows: 4,
          hint: '선택 입력 · 예: {"args":["--verbose"]}. 실행 서버는 위 선택값을 사용합니다.',
        },
        {
          key: "minimumAgeHours",
          label: "이미지 최소 보관 시간",
          type: "number",
        },
        {
          key: "dryRun",
          label: "삭제하지 않고 정리 후보만 확인",
          type: "checkbox",
        },
        {
          key: "pruneConfirmed",
          label: "예약 시점의 미사용 이미지를 실제 삭제하는 데 동의합니다",
          type: "checkbox",
        },
        {
          key: "misfirePolicy",
          label: "놓친 실행 처리",
          type: "select",
          options: [
            { value: "skip", label: "다음 예약부터 실행" },
            { value: "fire-once", label: "다시 시작하면 한 번 실행" },
          ],
        },
      ],
      row
        ? {
            ...row,
            scheduleServerId: row["args"]?.serverId || "",
            argsJson: JSON.stringify(row["args"] || {}, null, 2),
            minimumAgeHours: row["args"]?.minimumAgeHours ?? 168,
            dryRun: row["args"]?.dryRun !== false,
          }
        : {
            jobType: reportTypes[0] || "local-image-prune",
            cron: "0 0 4 * * ?",
            timezone: "Asia/Seoul",
            argsJson: "{}",
            minimumAgeHours: 168,
            dryRun: true,
            misfirePolicy: "skip",
            enabled: true,
          },
      "/schedules" + (row ? "/" + row["id"] : ""),
      row ? "PUT" : "POST",
    );
    if (!row) this.updateReportSchedule();
    this.previewSchedule();
  }
  public openEdit(row: Item): void {
    this.editing = row;
    if (this.section === "servers")
      this.openModal(
        "form",
        "서버 설정 수정",
        "호스트와 접속 정보를 변경합니다. 개인키는 별도의 키 교체 메뉴에서 관리합니다.",
        this.serverFields(true).filter((f) =>
          row["executionMode"] === "local"
            ? f.key === "name"
            : !["privateKey", "passphrase", "certificate"].includes(f.key),
        ),
        { ...row },
        "/servers/" + row["id"],
        "PUT",
      );
    else if (this.section === "templates") this.openTemplateEditor(row);
    else if (this.section === "macros") void this.openMacroEditor(row);
    else if (this.section === "schedules") this.openSchedule(row);
    else if (this.section === "services")
      this.openModal(
        "form",
        "서비스 구성 수정",
        "이름과 도메인을 수정합니다. 연결된 도메인 변경은 Cloudflare DNS와 Apache2에 함께 반영합니다. 새 이름을 포함하는 인증서가 필요하며, 빈 도메인은 기존 연결을 해제합니다.",
        [
          { key: "name", label: "서비스 이름", required: true },
          { key: "domain", label: "서비스 도메인" },
        ],
        { name: row['name'], domain: row['domain'] || '' },
        "/services/" + row["id"],
        "PUT",
      );
  }
  public async uploadField(event: Event, key: string): Promise<void> {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;
    if (key !== "archiveBase64" && file.size > 1024 * 1024) {
      this.modalError.set("1MB 이하의 텍스트 파일을 선택해 주세요.");
      input.value = "";
      return;
    }
    if (key === "archiveBase64") {
      if (file.size > 64 * 1024 * 1024) {
        this.modalError.set("64MB 이하의 tar 파일을 선택하세요.");
        return;
      }
      const reader = new FileReader();
      reader.onload = () =>
        (this.form[key] = String(reader.result).split(",")[1]);
      reader.readAsDataURL(file);
    } else this.form[key] = await file.text();
  }
  public closeModal(): void {
    if (this.busy()) return;
    this.modal.set("");
    this.composeSequence++;this.composeLoading.set(false);this.composeLoadError.set('');
    this.followLogs=false;this.logsSequence++;this.logSnapshot.set('');this.logsLoading.set(false);this.logsLoaded=false;
    this.versionContent.set(null);this.versionLoading.set(false);this.composeImageChanges.set([]);this.composeOriginal='';
    this.resetMacroDialog();
    clearTimeout(this.apacheTemplatePoll);this.apacheTemplateRequest++;this.apacheTemplateBusy.set(false);
    this.templateDraft = {};
    this.reportDocumentSequence++;
    this.reportDocument.set(null);
    clearTimeout(this.schedulePreviewTimer);
    this.schedulePreviewSequence++;
    this.schedulePreviewPending.set(false);
    this.syncPreviewSequence++;
    this.dnsSyncLoading.set(false);
    this.dnsSyncPreview.set(null);
    this.pruneLoadSequence++;
    this.imageTransferMode = "";
    this.pruneMode = "unused";
    this.form = {};
    this.editing = null;
    this.modalError.set("");
    setTimeout(() => this.returnFocus?.focus(), 0);
  }
  public async saveForm(): Promise<void> {
    if (this.busy()) return;
    if (this.isMacroEditor && (this.macroEditorLoading() || this.macroEditorLoadError())) return;
    if (this.isMacroRun && this.macroTargetsLoading()) return;
    for (const field of this.visibleFields) {
      if (field.required && String(this.form[field.key] ?? "").trim() === "") {
        this.modalError.set(field.label + "을(를) 입력해 주세요.");
        return;
      }
    }
    this.busy.set(true);
    this.modalError.set("");
    try {
      if (
        this.modal() === "migration-review" &&
        !this.form["maintenanceConfirmed"]
      )
        throw new Error("서비스 중단과 데이터 전송 영향을 확인해 주세요.");
      const dnsRecord = this.isDnsRecordForm;
      const serviceDomainEdit = this.isServiceDomainEdit;
      const zone = dnsRecord ? this.zones().find(zone => zone["id"] === this.form["zoneId"]) : null;
      if (dnsRecord && !zone) throw new Error("연결할 도메인 영역을 선택하세요.");
      if (dnsRecord && this.editing && !this.editing["managed"] && !this.form["confirmExternal"])
        throw new Error("외부 레코드 수정 내용을 확인하고 동의해 주세요.");
      if (dnsRecord && !this.editing) this.actionEndpoint = "/dns/zones/" + zone!["id"] + "/records";
      const data = dnsRecord ? dnsRecordPayload(this.form, zone!["name"]) : this.isMacroRun ? macroRunPayload(this.form) : this.isServiceDomainEdit ? {name:serviceDomainName(this.form['zoneName'],this.form['name']),type:'A',content:this.form['content'],ttl:1,proxied:false} : { ...this.form };
      if (this.isMacroEditor) {
        const error = macroAttachmentError(this.macroEditorFiles());
        if (error) throw new Error(error);
        data['retainedFileIds'] = this.macroEditorFiles().filter(file => file['id']).map(file => file['id']);
        data['files'] = this.macroEditorFiles().filter(file => !file['id']).map(file => ({ name: file['name'], base64: file['base64'] }));
      }
      if (this.isMacroRun && data['containerId'] && !this.macroContainers().some(container => container['id'] === data['containerId'] && container['state'] === 'running' && (!data['serviceId'] || container['serviceId'] === data['serviceId'])))
        throw new Error('선택 서버에서 실행할 컨테이너를 다시 선택하세요.');
      if (this.actionEndpoint.endsWith("/images/pull")) delete data["archiveBase64"];
      if (this.actionEndpoint.endsWith("/images/import")) delete data["image"];
      if (this.modal() === "prune") {
        data["digests"] = this.pruneCandidates.filter(image => !this.pruneCandidateBlocked(image) && this.selectedPruneImages().has(image["digest"]))
          .map(image => image["digest"]);
        if (this.pruneLoading() || !data["digests"].length) throw new Error("삭제할 이미지를 선택해 주세요.");
      }
      if (this.actionEndpoint === "/agent/maintenance" && !data["confirmed"])
        throw new Error("Agent 관리 작업 실행에 동의해 주세요.");
      if (data["deleteData"] && !data["dataDeletionConfirmed"])
        throw new Error("데이터 영구 삭제 확인을 선택해 주세요.");
      if (data["domainId"] === "") data["domainId"] = null;
      if ("certificateId" in data && !data["certificateId"])
        data["certificateId"] = null;
      if ("serviceId" in data && !data["serviceId"]) data["serviceId"] = null;
      if ("containerId" in data && !data["containerId"])
        data["containerId"] = null;
      if (data["argsJson"] !== undefined) {
        try {
          data["args"] = JSON.parse(data["argsJson"] || "{}");
          delete data["argsJson"];
        } catch {
          throw new Error("작업 옵션에 올바른 JSON 객체를 입력해 주세요.");
        }
      }
      if (
        this.section === "schedules" &&
        data["jobType"] === "macro-run" &&
        data["scheduleServerId"]
      )
        data["args"] = {
          ...(data["args"] || {}),
          serverId: data["scheduleServerId"],
        };
      if (this.actionEndpoint.startsWith("/schedules")) {
        data["timezone"] = "Asia/Seoul";
        if (this.actionMethod === "POST") data["enabled"] = true;
        else delete data["enabled"];
        if (this.schedulePreviewPending() || this.schedulePreviewError()) throw new Error(this.schedulePreviewError() || "실행 주기를 확인하고 있습니다.");
        if (data["jobType"] === "macro-run" && !data["scheduleServerId"])
          throw new Error("매크로를 실행할 서버를 선택하세요.");
        if (
          data["jobType"] === "local-image-prune" &&
          !data["dryRun"] &&
          !data["pruneConfirmed"]
        )
          throw new Error("미사용 이미지의 실제 삭제에 동의해 주세요.");
        if (data["jobType"] === "local-image-prune")
          data["args"] = {
            ...(this.editing?.["args"] || {}),
            minimumAgeHours: Number(data["minimumAgeHours"] ?? 168),
            dryRun: !!data["dryRun"],
            confirmed: !!data["pruneConfirmed"],
          };
        if (
          !["macro-run", "local-image-prune", "service-health", "dns-sync"].includes(
            data["jobType"],
          )
        ) {
          data["targetId"] = "";
          data["args"] = {};
        }
        if (["service-health", "dns-sync"].includes(data["jobType"])) data["args"] = {};
      }
      delete data["scheduleServerId"];
      delete data["minimumAgeHours"];
      delete data["dryRun"];
      delete data["pruneConfirmed"];
      if (this.actionEndpoint === "/auth/password" && (this.passwordLength(data["newPassword"]) < 12 || this.passwordLength(data["newPassword"]) > 72))
        throw new Error("비밀번호는 12~72자로 입력해 주세요. 문자 조합 제한은 없습니다.");
      if (
        data["newPassword"] &&
        data["newPassword"] !== data["confirmPassword"]
      )
        throw new Error("새 비밀번호 확인이 일치하지 않습니다.");
      if (data["proxied"] && !["A", "AAAA", "CNAME"].includes(data["type"]))
        throw new Error("프록시는 A, AAAA, CNAME에서만 사용할 수 있습니다.");
      if (
        this.section === "services" &&
        this.actionMethod === "PUT" &&
        !data["compose"]
      )
        delete data["compose"];
      if (data["port"]) data["port"] = Number(data["port"]);
      if (data["ttl"]) data["ttl"] = Number(data["ttl"]);
      if (data["priority"] != null && data["priority"] !== "")
        data["priority"] = Number(data["priority"]);
      if (this.actionEndpoint === "/anomaly-reports/settings") {
        if (data["recipients"] !== undefined)
          data["recipients"] = String(data["recipients"] || "")
            .split(/\r?\n/)
            .map((s) => s.trim())
            .filter(Boolean);
        if (!data["smtpPassword"]) delete data["smtpPassword"];
      }
      if (data["args"] && typeof data["args"] === "string")
        data["args"] = data["args"].split("\n").filter(Boolean);
      if (
        this.actionEndpoint.includes("/servers/") &&
        this.actionMethod === "PUT" &&
        !data["privateKey"]
      ) {
        delete data["privateKey"];
        delete data["passphrase"];
        delete data["certificate"];
      }
      if (this.actionEndpoint === "/servers" || this.actionEndpoint.endsWith("/setup")) data["consoleOrigin"] = location.origin;
      const macroContext = this.isMacroRun ? {
        ...this.macroRunSelection(), serverName: this.serverName(data['serverId']),
        serviceName: this.macroServices().find(service => service['id'] === data['serviceId'])?.['name'] || '',
        containerName: this.macroContainers().find(container => container['id'] === data['containerId'])?.['name'] || '',
        containerId: data['containerId'] || '',
      } : null;
      const result = await wiz.api.request<Item>(
        this.actionMethod,
        this.actionEndpoint,
        data,
      );
      if (macroContext) {
        this.macroExecutionContext.set(macroContext);
        this.macroExecution.set(result);
        this.macroExecutionError.set('');
        const sequence = ++this.macroExecutionSequence;
        clearTimeout(this.macroExecutionPoll);
        this.showMacroResult();
        void this.pollMacroExecution(result['id'], sequence);
        return;
      }
      if (this.isMacroEditor) this.resetMacroDialog();
      if (this.actionEndpoint === "/servers" && this.actionMethod === "POST") {
        this.modal.set("");
        this.form = {};
        // The destination resumes the durable setup operation returned with the server.
        await this.router.navigateByUrl("/servers/" + result["id"]);
        return;
      }
      if (this.actionEndpoint === "/services/bulk-actions") {
        this.editing = { results: items(result) };
        this.modalTitle = "서비스 일괄 작업 결과";
        this.modalDescription =
          "서비스별 접수 결과를 확인하세요. 접수한 작업은 백그라운드에서 진행됩니다.";
        this.modal.set("bulk-result");
        this.selectedServices.set(new Map());
        return;
      }
      if (this.actionEndpoint === "/agent/maintenance") {
        this.agentMaintenance.set(result);
        this.modalTitle = "Agent 관리 작업";
        this.modalDescription = "작업 상태와 로그인 안내를 확인하세요.";
        this.modal.set("agent-maintenance");
        this.form = {};
        return;
      }

      if (this.actionEndpoint === "/agent/template-jobs") {
        window.dispatchEvent(
          new CustomEvent("infra-agent-job", { detail: result }),
        );
        this.modal.set("");
        this.form = {};
        this.notify(
          "템플릿 초안을 요청했습니다. Agent 패널에서 진행 상황을 확인하세요.",
        );
        return;
      }
      if (this.actionEndpoint.endsWith("/migrations/plan")) {
        this.migrationPreview.set({
          ...result,
          checks: (result["checks"] || []).map((c: any) =>
            typeof c === "string"
              ? { name: c, passed: true, message: "이동 절차와 확인 사항" }
              : c,
          ),
        });
        if (!result["ready"])
          this.modalError.set(
            "이동 전 확인이 필요한 항목이 있습니다. 안내 내용을 해결한 후 다시 계획을 확인하세요.",
          );
        this.form = {
          targetServerId: data["targetServerId"],
          maintenanceConfirmed: false,
        };
        this.fields = [];
        this.actionEndpoint = "/services/" + this.id + "/migrations";
        this.modal.set("migration-review");
        return;
      }
      if (
        this.section === "servers" &&
        this.actionMethod === "PUT" &&
        data["privateKey"]
      )
        await wiz.api.post("/servers/" + this.editing!["id"] + "/credentials", {
          privateKey: data["privateKey"],
          passphrase: data["passphrase"],
          certificate: data["certificate"],
        });
      if (dnsRecord) this.selectedZone = String(zone!["id"]);
      this.modal.set("");
      this.form = {};
      if (
        this.id &&
        this.actionMethod === "DELETE" &&
        this.actionEndpoint === this.endpoint + "/" + this.id
      ) {
        await this.router.navigateByUrl(
          result?.["type"] && result?.["id"]
            ? "/operations/" + result["id"]
            : "/" + this.section,
        );
        return;
      }
      if (this.section === "images" && result?.["type"]?.startsWith("image-") && result?.["id"]) {
        this.operation.set(result);
        this.selectedImages.set(new Set());
        this.notify("이미지 작업이 접수되었습니다. 완료되면 목록을 갱신합니다.");
        setTimeout(() => this.returnFocus?.focus(), 0);
        return;
      }
      this.notify(
        ["queued", "pending", "running"].includes(result?.["status"])
          ? "작업이 접수되었습니다. 작업 기록에서 진행 상황을 확인하세요."
          : "저장했습니다.",
      );
      if (result?.["type"] && result?.["id"] && !serviceDomainEdit) this.operation.set(result);
      await this.load();
      if (this.id && this.tab !== "overview") await this.selectTab(this.tab);
      if (this.serverConfigurationOpen()) setTimeout(() => {
        if (this.returnFocus?.isConnected && !this.returnFocus.matches(':disabled')) this.returnFocus.focus();
        else document.querySelector<HTMLElement>('.server-configuration-dialog button:not(:disabled)')?.focus();
      }, 0);
    } catch (e) {
      this.modalError.set(errorMessage(e));
      if (this.serverConfigurationOpen()) setTimeout(() => (
        document.querySelector<HTMLElement>('.console-action-dialog input,.console-action-dialog textarea,.console-action-dialog select') ||
        document.querySelector<HTMLElement>('.console-action-dialog button:not(:disabled)')
      )?.focus(), 0);
    } finally {
      this.busy.set(false);
    }
  }
  public confirmAction(
    title: string,
    description: string,
    endpoint: string,
    body: Item = {},
    method = "POST",
  ): void {
    this.openModal("confirm", title, description, [], body, endpoint, method);
  }
  public deleteRow(row: Item): void {
    this.editing = row;
    if (this.section === "servers") {
      if (row["isControlHost"] || row["executionMode"] === "local") return;
      this.openModal("form", row["name"] + " 서버 연결 해제",
        "연결된 서비스와 진행 중인 작업을 먼저 종료하세요. SSH로 자동 등록한 키·수집기·실행기·sudo 설정·전용 파일을 정리하고 중앙 인증 정보·토큰·지표를 삭제합니다. Docker와 서비스 데이터, 기존 SSH 키는 보존합니다.",
        [{ key: "password", label: "SSH/sudo 패스워드 (선택)", type: "password", hint: "등록된 SSH 키와 해제 권한을 사용합니다. 이전 설치의 sudo 권한 또는 키 제거 후 재시도에 필요한 경우 입력하세요. 작업 종료 후 폐기합니다." }],
        {}, "/servers/" + row["id"], "DELETE");
      return;
    }
    this.confirmAction(
      (row["name"] || "항목") + " 삭제",
      "이 항목을 삭제합니다. 실행 중인 서비스와 연결된 자원은 서버에서 다시 확인합니다.",
      this.endpoint + "/" + row["id"],
      {},
      "DELETE",
    );
  }
  public async serverCheck(row: Item): Promise<void> {
    if (this.operation()) return;
    this.busy.set(true);
    this.error.set("");
    try {
      const op = await wiz.api.post<Item>("/servers/" + row["id"] + "/check");
      this.operation.set(op);
      this.notify("서버 점검을 접수했습니다.");
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public setupServer(row: Item): void {
    this.openModal("form", "서버 자동 구성", "저장된 SSH 키로 필요한 도구·Docker·실행기·수집기를 설치하고 지표 수신을 확인합니다. 기존 Docker와 서비스는 보존합니다.",
      row["username"] === "root" ? [] : [{ key: "password", label: "sudo 패스워드 (선택)", type: "password", hint: "비밀번호 없는 sudo 계정은 비워두세요. 구성 작업 종료 후 폐기합니다." }],
      {}, "/servers/" + row["id"] + "/setup");
  }
  public async discoverFingerprint(row: Item): Promise<void> {
    const trigger = document.activeElement as HTMLElement;
    this.busy.set(true);
    this.serverConfigurationError.set('');
    try {
      const data = await wiz.api.post<Item>(
        "/servers/" + row["id"] + "/fingerprint/discover",
      );
      this.openModal(
        "form",
        "서버 지문 확인",
        "서버 관리자가 별도 경로로 제공한 SHA256 지문과 아래 값을 대조한 후 저장하세요.",
        [
          {
            key: "fingerprint",
            label: "확인한 SSH 호스트 지문",
            required: true,
          },
        ],
        { fingerprint: data["fingerprint"] },
        "/servers/" + row["id"] + "/fingerprint",
      );
      if (this.serverConfigurationOpen()) this.returnFocus = trigger;
    } catch (e) {
      if (this.serverConfigurationOpen()) {
        this.serverConfigurationError.set(errorMessage(e));
        setTimeout(() => trigger?.focus(), 0);
      }
      else this.error.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public async checkService(): Promise<void> {
    if (!this.detail() || this.busy()) return;
    if (this.modal() !== 'preflight') {
      this.preflight.set(null);
      this.openModal('preflight','배포 사전 점검','서버 연결, Docker, Compose, 이미지·포트·경로와 도메인 연결을 확인합니다.',[]);
    }
    this.busy.set(true);
    this.modalError.set('');
    try {
      this.preflight.set(
        await wiz.api.post<Item>("/services/" + this.id + "/preflight"),
      );
      await this.load();
    } catch (e) {
      this.modalError.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public serviceAction(action: string): void {
    const d = this.detail()!;
    if (action === "remove") {
      this.openModal(
        "form",
        "서비스 제거",
        d["name"] +
          " · " +
          (d["serverName"] || this.serverName(d["serverId"])) +
          "의 컨테이너, 프록시와 관리 DNS 연결을 제거합니다. 기본값은 데이터 보존입니다.",
        [
          {
            key: "deleteData",
            label: "서비스 데이터도 영구 삭제합니다",
            type: "checkbox",
          },
          {
            key: "dataDeletionConfirmed",
            label: "데이터를 되돌릴 수 없음을 확인했습니다 (데이터 삭제 시)",
            type: "checkbox",
          },
        ],
        {
          action: "remove",
          serverId: d["serverId"],
          deleteData: false,
          dataDeletionConfirmed: false,
        },
        "/services/" + this.id + "/deployments",
      );
      return;
    }
    const labels: Item = {
      deploy: "서비스 배포",
      start: "서비스 시작",
      restart: "서비스 재시작",
      stop: "서비스 중지",
      remove: "서비스 제거",
    };
    this.confirmAction(
      labels[action] || "서비스 작업",
      (d["name"] || "서비스") +
        " · " +
        (d["serverName"] || this.serverName(d["serverId"])) +
        "에서 실행합니다. " +
        (action === "stop"
          ? "서비스 접속이 중단됩니다."
          : action === "remove"
            ? "관리 중인 서비스 실행 자원을 제거합니다."
            : "작업은 백그라운드에서 계속됩니다."),
      "/services/" + this.id + "/deployments",
      { action, serverId: d["serverId"] },
    );
  }
  public get isMacroRun(): boolean { return this.modal() === 'form' && /^\/macros\/[^/]+\/runs$/.test(this.actionEndpoint); }
  public get isMacroEditor(): boolean { return this.modal() === 'form' && this.actionMethod !== 'DELETE' && /^\/macros(?:\/[^/]+)?$/.test(this.actionEndpoint); }
  public macroRunSelection = signal<Item | null>(null);
  public macroExecution = signal<Item | null>(null);
  public macroExecutionContext = signal<Item>({});
  public macroExecutionError = signal('');
  private macroExecutionSequence = 0;
  private macroExecutionPoll: any;
  public get macroExecutionWorking(): boolean {
    return !!this.macroExecution() && !['succeeded','failed','canceled'].includes(this.macroExecution()!['status']);
  }
  public showMacroResult(): void {
    this.openModal('macro-result','매크로 실행 결과','현재 화면에서 진행 상황과 출력을 확인하세요.',[]);
  }
  public macroOutput(level: string): string {
    return (this.macroExecution()?.['events'] || []).filter((event: Item) => event['level'] === level)
      .map((event: Item) => event['message']).join('\n').replace(/\u001b\[[0-9;]*m/g,'');
  }
  public get macroExecutionEvents(): Item[] {
    return (this.macroExecution()?.['events'] || []).filter((event: Item) => !['stdout','stderr'].includes(event['level']));
  }
  private async pollMacroExecution(id: string, sequence: number): Promise<void> {
    if (sequence !== this.macroExecutionSequence) return;
    try {
      const operation = await wiz.api.get<Item>('/operations/' + id);
      if (sequence !== this.macroExecutionSequence) return;
      let events = this.mergeOperationEvents(this.macroExecution()?.['events'] || [], operation['events'] || []);
      if (events.length >= 1000) {
        let page: Item[];
        do {
          page = await wiz.api.get<Item[]>('/operations/' + id + '/events?after=' + events[events.length - 1]['id']);
          if (sequence !== this.macroExecutionSequence) return;
          events = this.mergeOperationEvents(events,page);
        } while (page.length === 1000);
      }
      this.macroExecution.set({...operation, events});
      this.macroExecutionError.set('');
      if (!this.macroExecutionWorking) return;
    } catch (error) {
      if (sequence !== this.macroExecutionSequence) return;
      this.macroExecutionError.set(errorMessage(error) + ' 진행 상황을 다시 조회합니다.');
    }
    this.macroExecutionPoll = setTimeout(() => void this.pollMacroExecution(id,sequence),2500);
  }
  public macroContainers = signal<Item[]>([]);
  public macroServices = signal<Item[]>([]);
  public macroTargetsLoading = signal(false);
  public macroTargetsError = signal('');
  public macroEditorFiles = signal<Item[]>([]);
  public macroEditorLoading = signal(false);
  public macroEditorLoadError = signal('');
  public macroAgentPrompt = '';
  public macroAgentBusy = signal(false);
  public macroAgentError = signal('');
  public macroAgentResult = signal<{script: string; summary: string} | null>(null);
  private macroDialogSequence = 0;
  private macroTargetSequence = 0;
  private macroAgentPoll: any;
  private resetMacroDialog(): void {
    this.macroRunSelection.set(null);
    this.macroDialogSequence++;this.macroTargetSequence++;clearTimeout(this.macroAgentPoll);
    this.macroContainers.set([]);this.macroServices.set([]);this.macroTargetsLoading.set(false);this.macroTargetsError.set('');
    this.macroEditorFiles.set([]);this.macroEditorLoading.set(false);this.macroEditorLoadError.set('');
    this.macroAgentPrompt = '';this.macroAgentBusy.set(false);this.macroAgentError.set('');this.macroAgentResult.set(null);
  }
  public async openMacroEditor(row?: Item): Promise<void> {
    this.editing = row || null;
    this.openModal('form', row ? '매크로 수정' : '매크로 만들기',
      '스크립트와 첨부파일을 저장합니다. 실행 시 같은 임시 경로에서 참조할 수 있습니다.',
      this.macroFields(), row ? {name:row['name'],description:row['description'],script:row['script']} : {name:'',description:'',script:''},
      row ? '/macros/' + row['id'] : '/macros', row ? 'PUT' : 'POST');
    if (!row) return;
    const sequence = this.macroDialogSequence;
    this.macroEditorLoading.set(true);
    try {
      const [macro, files] = await Promise.all([wiz.api.get<Item>('/macros/' + row['id']), wiz.api.get('/macros/' + row['id'] + '/files')]);
      if (sequence !== this.macroDialogSequence) return;
      // Metadata is fresh when the editor opens; inputs remain disabled during this load.
      this.form = {name:macro['name'],description:macro['description'],script:macro['script']};
      this.macroEditorFiles.set(items(files));
    } catch (error) { if (sequence === this.macroDialogSequence) this.macroEditorLoadError.set(errorMessage(error)); }
    finally { if (sequence === this.macroDialogSequence) this.macroEditorLoading.set(false); }
  }
  public async stageMacroFiles(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const chosen = Array.from(input.files || []);input.value = '';
    if (!chosen.length || this.macroEditorLoading()) return;
    const sequence = this.macroDialogSequence;
    const files = [...this.macroEditorFiles().filter(file => !chosen.some(candidate => candidate.name === file['name'])), ...chosen.map(file => ({name:file.name,size:file.size}))];
    const error = macroAttachmentError(files);
    if (error) { this.modalError.set(error);return; }
    this.macroEditorLoading.set(true);this.modalError.set('');
    try {
      const additions = await Promise.all(chosen.map(file => new Promise<Item>((resolve,reject) => {
        const reader = new FileReader();reader.onerror = () => reject(new Error('첨부파일을 읽지 못했습니다.'));
        reader.onload = () => resolve({name:file.name,size:file.size,base64:String(reader.result).split(',')[1]});reader.readAsDataURL(file);
      })));
      if (sequence === this.macroDialogSequence) this.macroEditorFiles.set([...files.slice(0,files.length-chosen.length),...additions]);
    } catch (error) { if (sequence === this.macroDialogSequence) this.modalError.set(errorMessage(error)); }
    finally { if (sequence === this.macroDialogSequence) this.macroEditorLoading.set(false); }
  }
  public removeMacroDraftFile(file: Item): void { this.macroEditorFiles.update(files => files.filter(candidate => candidate !== file)); }
  public async requestMacroAgent(): Promise<void> {
    if (this.macroAgentBusy() || this.macroEditorLoading() || this.busy()) return;
    if (!this.macroAgentPrompt.trim()) { this.macroAgentError.set('Agent에 요청할 내용을 입력하세요.');return; }
    const sequence = this.macroDialogSequence;
    this.macroAgentBusy.set(true);this.macroAgentError.set('');this.macroAgentResult.set(null);
    try {
      const job = await wiz.api.post<Item>('/agent/macro-assist',{prompt:this.macroAgentPrompt,script:this.form['script'] || '',fileNames:this.macroEditorFiles().map(file => file['name'])});
      if (sequence === this.macroDialogSequence) this.pollMacroAgent(job['id'],sequence);
    } catch (error) { if (sequence === this.macroDialogSequence) {this.macroAgentError.set(errorMessage(error));this.macroAgentBusy.set(false);} }
  }
  private pollMacroAgent(id: string,sequence: number): void {
    this.macroAgentPoll = setTimeout(async () => {
      if (sequence !== this.macroDialogSequence) return;
      try {
        const job = await wiz.api.get<Item>('/agent/jobs/' + id);
        if (sequence !== this.macroDialogSequence) return;
        if (['succeeded','failed','canceled'].includes(job['status'])) {
          if (job['status'] !== 'succeeded') throw new Error('Agent 작성을 완료하지 못했습니다.');
          const draft = await wiz.api.get<Item>('/agent/jobs/' + id + '/macro-draft');
          if (sequence !== this.macroDialogSequence) return;
          this.macroAgentResult.set(macroAgentDraft(draft));this.macroAgentBusy.set(false);return;
        }
        this.pollMacroAgent(id,sequence);
      } catch (error) { if (sequence === this.macroDialogSequence) {this.macroAgentError.set(errorMessage(error));this.macroAgentBusy.set(false);} }
    },1000);
  }
  public applyMacroAgent(): void { const result = this.macroAgentResult();if (result) {this.form['script'] = result.script;this.macroAgentResult.set(null);} }
  public openMacroRun(row: Item): void {
    this.openModal('form','매크로 실행','서버를 먼저 선택하고, 필요하면 서비스와 컨테이너를 선택하세요.',[],
      {serverId:'',serviceId:'',containerId:'',args:''},'/macros/' + row['id'] + '/runs');
    this.macroRunSelection.set({name:row['name'],description:row['description'],version:row['version']});
  }
  public async loadMacroTargets(): Promise<void> {
    const server = this.form['serverId'];const sequence = ++this.macroTargetSequence;
    this.form['serviceId'] = '';this.form['containerId'] = '';this.macroContainers.set([]);this.macroServices.set([]);this.macroTargetsError.set('');
    this.macroTargetsLoading.set(!!server);if (!server) return;
    try {
      const [inventory, services] = await Promise.all([wiz.api.get('/servers/' + server + '/containers'),this.allChoices('/services')]);
      if (sequence === this.macroTargetSequence) { this.macroContainers.set(items(inventory));this.macroServices.set(services); }
    } catch (error) { if (sequence === this.macroTargetSequence) this.macroTargetsError.set(errorMessage(error)); }
    finally { if (sequence === this.macroTargetSequence) this.macroTargetsLoading.set(false); }
  }
  public connectZone(): void {
    this.editing = null;
    this.openModal(
      "form",
      "Cloudflare Zone 연결",
      "Zone 조회와 DNS 편집 권한을 가진 최소 범위의 API 토큰을 사용하세요.",
      [
        {
          key: "name",
          label: "Zone 이름",
          required: true,
          hint: "예: example.com",
          placeholder: "example.com",
        },
        { key: "cloudflareId", label: "Cloudflare Zone ID", required: true, placeholder: "0123456789abcdef0123456789abcdef" },
        {
          key: "token",
          label: "Cloudflare API 토큰",
          type: "password",
          required: true,
          placeholder: "Zone DNS 편집 권한 API 토큰",
        },
      ],
      {},
      "/dns/zones",
    );
  }
  public manageZone(): void {
    const zone = this.zones().find(item => item["id"] === this.selectedZone);
    if (!zone) return;
    this.editing = zone;
    this.openModal(
      "form",
      "DNS 영역 관리",
      "연결 정보만 변경합니다. API 토큰을 비워 두면 기존 토큰을 유지합니다.",
      [
        { key: "name", label: "Zone 이름", required: true, placeholder: "example.com" },
        { key: "cloudflareId", label: "Cloudflare Zone ID", required: true, placeholder: "0123456789abcdef0123456789abcdef" },
        { key: "token", label: "새 Cloudflare API 토큰 (선택)", type: "password", placeholder: "변경할 때만 입력", hint: "비워 두면 저장된 API 토큰을 유지합니다." },
      ],
      { name: zone["name"], cloudflareId: zone["cloudflareId"], token: "" },
      "/dns/zones/" + zone["id"],
      "PUT",
    );
  }
  public confirmZoneDelete(): void {
    const zone = this.editing;
    if (!zone) return;
    this.confirmAction(
      "DNS 영역 연결 해제",
      String(zone["name"]) + "의 로컬 연결 정보와 캐시된 레코드를 삭제합니다. Cloudflare의 실제 DNS 레코드는 변경하지 않습니다. 서비스 연결이 남아 있으면 해제할 수 없습니다.",
      "/dns/zones/" + zone["id"],
      {},
      "DELETE",
    );
  }
  public async syncZone(): Promise<void> {
    if (!this.selectedZone || this.busy()) return;
    const zone = this.selectedZone, sequence = ++this.syncPreviewSequence;
    this.dnsSyncPreview.set(null); this.dnsSyncLoading.set(true);
    this.openModal("dns-sync", "DNS 동기화 확인", "Cloudflare의 현재 값을 로컬 목록에 반영합니다. Cloudflare 레코드는 변경하지 않습니다.", []);
    try {
      const preview = await wiz.api.get<Item>("/dns/zones/" + zone + "/sync-preview");
      if (sequence === this.syncPreviewSequence && this.modal() === "dns-sync") this.dnsSyncPreview.set(preview);
    } catch (e) { if (sequence === this.syncPreviewSequence) this.modalError.set(errorMessage(e)); }
    finally { if (sequence === this.syncPreviewSequence) this.dnsSyncLoading.set(false); }
  }
  public async applyDnsSync(): Promise<void> {
    const preview = this.dnsSyncPreview();
    if (!preview || this.busy() || this.dnsSyncLoading()) return;
    this.busy.set(true); this.modalError.set("");
    try {
      const result = await wiz.api.post<Item>("/dns/zones/" + preview["zoneId"] + "/sync", {revision:preview["revision"]});
      this.operation.set(result); this.modal.set(""); this.dnsSyncPreview.set(null);
      this.notify("확인한 변경 사항의 동기화를 요청했습니다. 완료 후 목록을 갱신합니다.");
    } catch (e) { this.modalError.set(errorMessage(e)); }
    finally { this.busy.set(false); }
  }
  public openRecord(row?: Item): void {
    this.editing = row || null;
    const values = row ? { ...row, zoneId: row["zoneId"] || this.selectedZone, confirmExternal: false } :
      { zoneId: this.selectedZone, type: this.dnsType || "A", ttl: 1, proxied: false, name: "", content: "" };
    this.openModal("form", row ? "DNS 레코드 수정" : "DNS 레코드 추가",
      row ? "저장하면 DNS 레코드와 연결된 Apache2 설정을 함께 수정합니다." : "연결할 도메인 영역과 레코드 이름·대상을 지정하세요.",
      dnsRecordFields(this.zones(), values, !!row), values,
      row ? "/dns/records/" + row["id"] : "/dns/zones/" + this.selectedZone + "/records", row ? "PATCH" : "POST");
  }
  public deleteDnsRecord(row: Item): void {
    this.confirmAction("DNS 레코드 삭제", row["name"] + " (" + row["type"] + ") → " + row["content"] +
      " · Cloudflare 레코드와 연결된 Apache2 설정을 함께 삭제합니다. DNS 연결에 영향을 줍니다." + (!row["managed"] ? " 외부에서 생성한 레코드입니다." : ""),
      "/dns/records/" + row["id"] + (!row["managed"] ? "?confirmExternal=true" : ""), {}, "DELETE");
  }
  public reportCreate(): void {
    this.openModal(
      "form",
      "운영 리포트 생성",
      "완료된 기간의 서버 지표와 서비스 상태를 분석합니다.",
      [
        {
          key: "period",
          label: "분석 기간",
          type: "select",
          required: true,
          options: [
            { value: "daily", label: "일간 · 완료된 전일" },
            { value: "weekly", label: "주간 · 완료된 직전 주" },
            { value: "monthly", label: "월간 · 완료된 직전 달" },
          ],
        },
      ],
      { period: "daily" },
      "/anomaly-reports/runs",
    );
  }
  public async saveSettings(): Promise<void> {
    this.busy.set(true);
    this.error.set("");
    try {
      this.settings.set(
        await wiz.api.patch<Item>("/system/settings", {title:this.settings()["title"],sessionTimeoutMinutes:this.settings()["sessionTimeoutMinutes"]}),
      );
      window.dispatchEvent(new Event("infra-appearance-change"));
      this.notify("워크스페이스 설정을 저장했습니다.");
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public async saveDnsTargets(): Promise<void> {
    this.busy.set(true);this.error.set("");
    try {
      const result=await wiz.api.request<Item>("PUT","/system/dns-targets",{addresses:this.dnsAddressOptions,defaultAddress:this.dnsDefaultAddress||null});
      this.dnsAddressesText=(result.addresses || []).join("\n");this.dnsDefaultAddress=result.defaultAddress || "";
      this.notify("DNS 연결 주소를 저장했습니다.");
    } catch(error) { this.error.set(errorMessage(error)); }
    finally { this.busy.set(false); }
  }
  public changePassword(): void {
    this.openModal(
      "form",
      "관리자 비밀번호 변경",
      "현재 비밀번호를 확인한 후 새 비밀번호를 저장합니다.",
      [
        {
          key: "currentPassword",
          label: "현재 비밀번호",
          type: "password",
          required: true,
        },
        {
          key: "newPassword",
          label: "새 비밀번호",
          type: "password",
          required: true,
          hint: "12~72자 · 문자 조합 제한 없음",
        },
        {
          key: "confirmPassword",
          label: "새 비밀번호 확인",
          type: "password",
          required: true,
        },
      ],
      {},
      "/auth/password",
      "PATCH",
    );
  }
  public async uploadAppearance(event: Event, kind: string): Promise<void> {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    this.busy.set(true);
    try {
      const data = new FormData();
      data.append("file", file);
      this.appearance.set(
        await wiz.api.post<Item>("/system/appearance/" + kind, data),
      );
      window.dispatchEvent(new Event("infra-appearance-change"));
      this.notify("브랜딩 이미지를 저장했습니다.");
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public async openWizard(): Promise<void> {
    this.returnFocus = document.activeElement as HTMLElement;
    this.busy.set(true);
    this.error.set("");
    try {
      const [templates, servers] = await Promise.all([
        wiz.api.get("/templates"),
        wiz.api.get("/servers"),
      ]);
      this.certificates.set([]);
      this.zones.set([]);
      this.wizardDnsAddresses.set([]);
      this.wizardDomainsLoaded = false;
      this.wizardDomainError.set("");
      this.revealedInputs = {};
      this.templates.set(items(templates));
      this.templatePage = 1;
      this.templateHasMore = items(templates).length === 20;
      this.servers.set(
        items(servers).sort(
          (a, b) => (a["score"] ?? 999) - (b["score"] ?? 999),
        ),
      );
      this.step = 1;this.furthestStep=1;this.savedWizardSignature="";this.savedWizardDomain=null;
      this.source = "template";
      this.selectedTemplate = "";
      this.values = {};
      this.draft = {
        name: "",
        compose: "",
        domain: "",
        zoneId: "",
        recordId: "",
        targetHost: "",
        targetPort: 80, domainEnabled:false, dnsContent:'', proxied:false,
        serverId: "",
      };
      this.savedDraft = null;
      this.preflight.set(null);
      this.modalError.set("");
      const templateId = this.route.snapshot.queryParamMap.get("templateId");
      if (templateId) {
        let chosen = this.templates().find((t) => t["id"] === templateId);
        if (!chosen) {
          chosen = await wiz.api.get<Item>(
            "/templates/" + encodeURIComponent(templateId),
          );
          this.templates.update((t) => [chosen!, ...t]);
        }
        this.chooseTemplate(chosen);
      }
      this.wizard.set(true);
      setTimeout(
        () => document.querySelector<HTMLElement>(".modal button")?.focus(),
        0,
      );
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public chooseTemplate(t: Item): void {
    if(this.selectedTemplate===t['id'])return;
    this.wizardChanged();
    this.selectedTemplate = t["id"];
    this.values = templateDefaults(t);
    this.revealedInputs = {};
  }
  public async loadWizardDomains(): Promise<void> {
    if (this.wizardDomainsLoaded || this.wizardDomainLoading()) return;
    this.wizardDomainLoading.set(true);
    this.wizardDomainError.set("");
    try {
      const [zones,targets] = await Promise.all([wiz.api.get("/dns/zones"),wiz.api.get<Item>("/system/dns-targets")]);
      if (!this.wizard()) return;
      this.zones.set(items(zones));
      this.wizardDnsAddresses.set((targets.addresses || []).filter((address:string)=>/^\d{1,3}(\.\d{1,3}){3}$/.test(address)));
      if (!this.wizardDnsAddresses().includes(this.draft.dnsContent)) this.draft.dnsContent=this.wizardDnsAddresses().includes(targets.defaultAddress) ? targets.defaultAddress : '';
      this.wizardDomainsLoaded = true;
    } catch (error) {
      this.wizardDomainError.set(errorMessage(error));
    } finally {
      this.wizardDomainLoading.set(false);
    }
  }
  public wizardChanged(): void { this.modalError.set('');this.preflight.set(null); }
  private wizardSignature(): string { return JSON.stringify({source:this.source,template:this.selectedTemplate,values:this.values,name:this.draft.name,compose:this.source==='manual'?this.draft.compose:null,serverId:this.draft.serverId,domain:this.domainPayload()}); }
  public domainPayload(): Item | null {
    if (!this.draft.domainEnabled) return null;
    return {zoneId:this.draft.zoneId,type:'A',name:this.draft.domain,content:this.draft.dnsContent,ttl:1,proxied:false,targetHost:this.draft.targetHost||null,targetPort:this.draft.targetPort?Number(this.draft.targetPort):null};
  }
  public canVisitWizardStep(step: number): boolean { return !this.busy() && step>=1 && step<=this.furthestStep; }
  private async validateWizardStep(step: number): Promise<boolean> {
    if(step===1 && this.source==='template' && !this.selectedTemplateObject?.enabled) this.modalError.set('사용 가능한 템플릿을 선택해 주세요.');
    if(step===2){
      const error=serviceNameError(this.draft.name)||(this.source==='template'?templateInputError(this.selectedTemplateObject,this.values):!this.draft.compose?.trim()?'Compose 구성을 입력해 주세요.':'');
      if(error)this.modalError.set(error);
      else if(this.source==='template'){
        const preview=await wiz.api.post<Item>('/templates/'+this.selectedTemplate+'/preview',{values:this.values});
        if(!preview.valid)this.modalError.set((preview.errors||[]).join('\n')||'템플릿 입력값을 확인해 주세요.');
        else this.draft.compose=preview.compose;
      }
    }
    if(step===3 && !this.servers().some(server=>server.id===this.draft.serverId&&server.eligible))this.modalError.set('배포할 서버를 직접 선택해 주세요.');
    if(step===4 && this.draft.domainEnabled){
      const zone=this.zones().find(zone=>zone.id===this.draft.zoneId);
      if(!zone || !this.draft.domain || !(this.draft.domain===zone.name||this.draft.domain.endsWith('.'+zone.name)))this.modalError.set('Zone을 선택하고 해당 영역의 전체 도메인 이름을 입력하세요.');
      else if(!this.wizardDnsAddresses().includes(this.draft.dnsContent))this.modalError.set('DNS 연결 주소를 선택하세요.');
      else if((this.source==='manual'||!this.selectedTemplateObject?.publicEndpoint?.service) && !(Number(this.draft.targetPort)>=1&&Number(this.draft.targetPort)<=65535))this.modalError.set('프록시 대상 호스트 포트를 입력하세요.');
    }
    return !this.modalError();
  }
  public async wizardGo(target: number): Promise<void> {
    if(!this.canVisitWizardStep(target))return;
    this.modalError.set('');
    if(target<=this.step){this.step=target;return;}
    this.busy.set(true);
    try{for(let current=this.step;current<target;current++){if(!await this.validateWizardStep(current)){this.step=current;return;}}this.step=target;}
    catch(error){this.modalError.set(errorMessage(error));}finally{this.busy.set(false);}
  }
  public async wizardNext(): Promise<void> {
    if(this.busy())return;
    if(this.step===5){await this.prepareDeploy();return;}
    this.modalError.set('');this.busy.set(true);
    try{if(!await this.validateWizardStep(this.step))return;this.step++;this.furthestStep=Math.max(this.furthestStep,this.step);}
    catch(error){this.modalError.set(errorMessage(error));}finally{this.busy.set(false);}
  }
  public async prepareDeploy(): Promise<void> {
    if(this.busy())return;
    this.busy.set(true);this.modalError.set('');this.preflight.set(null);
    try{
      for(let step=1;step<5;step++){if(!await this.validateWizardStep(step)){this.step=step;return;}}
      const signature=this.wizardSignature();
      const payload={name:this.draft.name,templateId:this.source==='template'?this.selectedTemplate:null,values:this.values,compose:this.source==='manual'?this.draft.compose:null,serverId:this.draft.serverId,domain:null};
      if(this.savedDraft && signature!==this.savedWizardSignature){
        if(this.savedWizardDomain){await wiz.api.request('DELETE','/services/'+this.savedDraft.id+'/domains/'+this.savedWizardDomain.id);this.savedWizardDomain=null;}
        this.savedDraft=await wiz.api.request<Item>('PUT','/services/'+this.savedDraft.id+'/draft',payload);
      }else if(!this.savedDraft)this.savedDraft=await wiz.api.post<Item>('/services',payload);
      this.savedWizardSignature=signature;
      if(this.source==='template')this.draft.compose=(await wiz.api.get<Item>('/services/'+this.savedDraft.id)).compose;
      if(this.draft.domainEnabled&&!this.savedWizardDomain)this.savedWizardDomain=await wiz.api.post<Item>('/services/'+this.savedDraft.id+'/domains/new',this.domainPayload());
      this.preflight.set(await wiz.api.post<Item>('/services/'+this.savedDraft.id+'/preflight'));
      if(!this.preflight()?.ready)this.modalError.set('사전 점검에서 확인이 필요한 항목이 있습니다. 초안은 저장되었습니다.');
    }catch(error){this.modalError.set(errorMessage(error));}finally{this.busy.set(false);}
  }
  public async deployDraft(): Promise<void> {
    if (
      !this.savedDraft ||
      !this.preflight()?.["ready"] ||
      !this.draft["serverId"] || this.wizardSignature()!==this.savedWizardSignature
    )
      return;
    this.busy.set(true);
    try {
      const op = await wiz.api.post<Item>(
        "/services/" + this.savedDraft["id"] + "/deployments",
        { action: "deploy", serverId: this.draft["serverId"] },
      );
      this.operation.set(op);
      this.wizard.set(false);
      this.values = {};
      this.draft = {};
      this.savedDraft = null;
      this.notify("배포를 접수했습니다. 작업 기록에서 상태를 확인하세요.");
      await this.load();
      if (this.id && this.tab !== "overview") await this.selectTab(this.tab);
    } catch (e) {
      this.modalError.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public closeWizard(): void {
    if (this.busy()) return;
    this.wizard.set(false);
    this.revealedInputs = {};
    if (this.savedDraft) void this.load();
    this.values = {};
    this.draft = {};
    this.savedDraft = null;this.savedWizardDomain=null;this.savedWizardSignature='';
    this.preflight.set(null);
    setTimeout(() => this.returnFocus?.focus(), 0);
  }
  public async pollOperation(): Promise<void> {
    if (this.operationPolling) return;
    this.operationPolling = true;
    try {
      if (
        this.section === "operations" && !this.id && !this.loading() &&
        this.rows().some((row) => ["pending", "queued", "preparing", "running", "verifying"].includes(row["status"]))
      ) {
        const page = this.page;
        const query = this.operationQuery;
        const response = await wiz.api.getPage<Item>(
          "/operations?page=" + page + "&size=" + this.pageSize + query,
        );
        // A poll started before a filter/page change must not replace the new list.
        if (!this.id && !this.loading() && page === this.page && query === this.operationQuery) {
          this.total = response.total;
          if (this.page > this.pages) {
            this.page = this.pages;
            await this.load();
          } else this.rows.set(response.items);
        }
      }
      if (this.operation()?.["id"]) {
        const op = await wiz.api.get<Item>(
          "/operations/" + this.operation()!["id"],
        );
        this.operation.set(op);
        if (op["type"] === "server-setup" && this.section === "servers" && op["targetId"] === this.id) this.serverSetupOperation.set(op);
        if (op["type"] === "server-unregister" && this.section === "servers" && op["targetId"] === this.id) this.serverDisconnectOperation.set(op);
        if (["succeeded", "failed", "canceled"].includes(op["status"])) {
          this.notify(
            "작업 " + status(op["status"]) + " · " + (op["message"] || ""),
            op["status"] === "failed" ? "error" : op["status"] === "canceled" ? "warn" : "success",
          );
          this.operation.set(null);
          if (op["type"] === "server-unregister" && op["status"] === "succeeded" && this.section === "servers") {
            if (this.id === op["targetId"]) await this.router.navigateByUrl("/servers");
            else await this.load();
            return;
          }
          if (this.id)
            this.detail.set(
              await wiz.api.get<Item>(this.endpoint + "/" + this.id),
            );
          else if (this.section === "images" && op["targetId"] === this.selectedServer) await this.loadImages(true);
          else if (this.section === "domains") await this.load();
          if (this.tab === "ai-audit") await this.loadAudit(true);
          else if (this.section === "reports") await this.load();
          else if (
            (this.section === "services" && op["targetType"] === "service") ||
            (this.section === "servers" && op["targetType"] === "server")
          ) {
            const changed = await wiz.api.get<Item>(
              this.endpoint + "/" + op["targetId"],
            );
            this.rows.update((rows) =>
              rows.map((r) => (r["id"] === changed["id"] ? changed : r)),
            );
          }
        }
      }
      if (
        this.section === "operations" &&
        this.id &&
        ["pending", "running", "queued", "preparing", "verifying"].includes(
          this.detail()?.["status"],
        )
      )
      {
        const operationId = this.id;
        const updated = await wiz.api.get<Item>("/operations/" + operationId);
        if (this.id !== operationId) return;
        const current = this.detail()?.["events"] || [];
        updated["events"] = this.mergeOperationEvents(current, updated["events"] || []);
        this.detail.set(updated);
        if (current.length >= 1000) await this.loadMoreOperationEvents();
        else this.operationEventsRemaining = updated["events"].length >= 1000;
      }
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.operationPolling = false;
    }
  }
  private mergeOperationEvents(current: Item[], incoming: Item[]): Item[] {
    return [...new Map([...current, ...incoming].map(event => [event["id"], event])).values()]
      .sort((a, b) => a["id"] - b["id"]);
  }
  public async loadMoreOperationEvents(): Promise<void> {
    if (this.operationEventsLoading() || this.section !== "operations" || !this.id) return;
    const operationId = this.id;
    const events = this.detail()?.["events"] || [];
    const after = events.length ? events[events.length - 1]["id"] : 0;
    this.operationEventsLoading.set(true);
    try {
      const next = await wiz.api.get<Item[]>("/operations/" + operationId + "/events?after=" + after);
      if (this.id !== operationId) return;
      this.detail.update(current => current && ({ ...current, events: this.mergeOperationEvents(current["events"] || [], next) }));
      this.operationEventsRemaining = next.length >= 1000;
    } catch (error) {
      this.error.set(errorMessage(error));
    } finally {
      this.operationEventsLoading.set(false);
    }
  }
  public async copy(value: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(value);
      this.notify("클립보드에 복사했습니다.");
    } catch (e) {
      this.error.set(
        "클립보드에 복사할 수 없습니다. 내용을 직접 선택해 복사해 주세요.",
      );
    }
  }
  public json(value: any): string {
    return JSON.stringify(value, null, 2);
  }
  public keys(value: any): string[] {
    return value && typeof value === "object" ? Object.keys(value) : [];
  }
  public jobLabel(value: string): string {
    return (
      {
        "local-image-prune": "미사용 이미지 정리",
        "dns-sync": "DNS 동기화",
        "macro-run": "매크로 실행",
        "anomaly-daily": "일간 리포트",
        "anomaly-weekly": "주간 리포트",
        "anomaly-monthly": "월간 리포트",
        "service-health": "서비스 상태 점검",
        "certificate-renewal-check": "인증서 갱신 점검",
      }[value] || value
    );
  }
  public reportPresets: Item[] = [];
  public async reportSettings(): Promise<void> {
    this.busy.set(true);
    try {
      const [data, presets] = await Promise.all([
        wiz.api.get<Item>("/anomaly-reports/settings"),
        wiz.api.get<Item[]>("/anomaly-reports/threshold-presets"),
      ]);
      this.reportPresets = presets;
      const keys = ["recipients", "thresholdPreset", "cpuThreshold", "memoryThreshold",
        "storageThreshold", "failureThreshold", "sustainedMinutes", "minCoveragePercent"];
      const form: Item = {};
      for (const key of keys) form[key] = data[key];
      form["recipients"] = Array.isArray(data["recipients"])
        ? data["recipients"].join("\n") : data["recipients"];
      this.openModal(
        "form", "리포트 분석 설정",
        "분석 기준을 선택하세요. 이상이 감지되면 Agent가 자동으로 분석합니다.",
        [
          { key: "cpuThreshold", label: "CPU 임계치 (%)", type: "number", required: true },
          { key: "memoryThreshold", label: "메모리 임계치 (%)", type: "number", required: true },
          { key: "storageThreshold", label: "스토리지 임계치 (%)", type: "number", required: true },
          { key: "failureThreshold", label: "연속 실패 기준", type: "number", required: true,
            hint: "서비스 상태 점검이 이 횟수만큼 연속으로 실패하면 이상으로 기록합니다. 정상 관측 시 실패 횟수는 초기화됩니다. 서비스별 기준이 있으면 그 값을 사용합니다." },
          { key: "sustainedMinutes", label: "임계치 지속 시간 (분)", type: "number", required: true,
            hint: "CPU·메모리·스토리지 중 하나 이상이 임계치 이상인 상태가 이 시간 동안 이어지면 이상으로 판단합니다. 수집 간격이 3분을 넘으면 연속 구간이 끊깁니다." },
          { key: "minCoveragePercent", label: "최소 수집률 (%)", type: "number", required: true,
            hint: "분석 기간의 전체 시간 구간 중 지표가 수집된 구간의 비율입니다. 일간은 10분, 주간은 1시간, 월간은 6시간 단위로 계산하며, 기준 미만이면 수집 부족으로 알립니다. 누락 구간은 정상으로 간주하지 않습니다." },
        ], form, "/anomaly-reports/settings", "PATCH",
      );
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public reportThresholdReadOnly(key: string): boolean {
    return (
      this.actionEndpoint === "/anomaly-reports/settings" &&
      this.form["thresholdPreset"] !== "manual" &&
      [
        "cpuThreshold",
        "memoryThreshold",
        "storageThreshold",
        "failureThreshold",
        "sustainedMinutes",
        "minCoveragePercent",
      ].includes(key)
    );
  }
  public applyReportPreset(): void {
    const preset = this.reportPresets.find(
      (p) => p["id"] === this.form["thresholdPreset"],
    );
    if (preset)
      for (const key of [
        "cpuThreshold",
        "memoryThreshold",
        "storageThreshold",
        "failureThreshold",
        "sustainedMinutes",
        "minCoveragePercent",
      ])
        this.form[key] = preset[key];
  }
  public updateReportSchedule(): void {
    const crons: Item = {
      "dns-sync": "0 50 3 * * ?",
      "anomaly-daily": "0 0 4 * * ?",
      "anomaly-weekly": "0 0 4 ? * MON",
      "anomaly-monthly": "0 0 4 1 * ?",
    };
    if (crons[this.form["jobType"]]) {
      this.form["cron"] = crons[this.form["jobType"]];
      this.form["targetId"] = "";
      this.form["argsJson"] = "{}";
      if (!this.form["name"])
        this.form["name"] = this.jobLabel(this.form["jobType"]);
    }
  }
  public healthcheckLabel(value: string): string {
    return (
      {
        declared: "Compose 정의",
        disabled: "Compose 비활성",
        inherited: "이미지 기본값",
        unmatched: "구성 외 컨테이너",
        unknown: "구성 미확인",
      }[value] || value
    );
  }
  public async importCompose(file: Item): Promise<void> {
    this.busy.set(true);
    try {
      const data = await wiz.api.get<Item>(
        "/servers/" +
          this.id +
          "/files/compose?path=" +
          encodeURIComponent(file["path"]),
      );
      await this.openWizard();
      this.source = "manual";
      this.step = 2;
      this.draft["compose"] = data["compose"];
      this.draft["name"] = file["name"].replace(/\.(yaml|yml)$/, "");
      this.notify(
        "Compose를 읽었습니다. 배포할 서버는 다음 단계에서 선택해 주세요.",
      );
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public imagePull(): void {
    this.openModal(
      "form",
      "이미지 가져오기",
      "가져올 방식을 선택하세요.",
      [],
      {},
      "",
    );
    this.setImageTransferMode("registry");
  }
  public imageImport(): void {
    this.imagePull();
    this.setImageTransferMode("file");
  }
  public setImageTransferMode(mode: "registry" | "file"): void {
    if (this.busy()) return;
    this.imageTransferMode = mode;
    this.modalDescription = mode === "registry"
      ? "선택한 서버에서 레지스트리 이미지를 내려받습니다."
      : "선택한 서버의 Docker에 64MB 이하 tar 이미지를 가져옵니다.";
    this.fields = mode === "registry"
      ? [{
          key: "image",
          label: "이미지 참조",
          required: true,
          hint: "예: nginx:1.29 또는 registry.example.com/app:version",
        }]
      : [{
          key: "archiveBase64",
          label: "Docker 이미지 tar",
          type: "file",
          required: true,
        }];
    this.actionEndpoint = "/servers/" + this.selectedServer + "/images/" +
      (mode === "registry" ? "pull" : "import");
    this.modalError.set("");
  }
  public async previewPrune(
    mode: "unused" | "selection" | "versions" = "unused",
    requestedDigests = new Set<string>(),
    repository = "",
  ): Promise<void> {
    if (this.imageWorking || !this.selectedServer) return;
    const serverId = this.selectedServer;
    const selected = requestedDigests.size
      ? new Set(requestedDigests)
      : mode === "selection"
        ? new Set(this.selectedImages())
        : new Set<string>();
    const sequence = ++this.pruneLoadSequence;
    this.prunePreview.set(null);
    this.selectedPruneImages.set(new Set());
    this.pruneLoading.set(true);
    this.openModal(
      "prune",
      mode === "versions" ? repository + " 버전 삭제" : mode === "selection" ? "선택한 이미지 삭제" : "미사용 이미지 정리",
      mode === "versions"
        ? "삭제할 버전을 선택하세요. 사용 중이거나 보호된 버전은 삭제할 수 없습니다."
        : this.serverName(serverId) + " 서버의 미사용 이미지입니다. 삭제에서 제외할 항목은 체크를 해제하세요.",
      [], { confirmed: true }, "/servers/" + serverId + "/images/prune",
    );
    this.pruneMode = mode;
    try {
      const data = await wiz.api.get<Item>("/servers/" + serverId + "/images");
      if (sequence !== this.pruneLoadSequence || this.modal() !== "prune" || serverId !== this.selectedServer) return;
      if (data["error"]) throw new Error(data["error"]);
      const candidates = items(data).filter(image => mode === "unused"
        ? !this.imageUsed(image)
        : selected.has(String(image["digest"] || image["id"] || "")));
      this.prunePreview.set({ serverId, candidates });
      this.selectedPruneImages.set(new Set(candidates.filter(image => !this.pruneCandidateBlocked(image)).map(image => image["digest"])));
    } catch (e) {
      if (sequence === this.pruneLoadSequence) this.modalError.set(errorMessage(e));
    } finally {
      if (sequence === this.pruneLoadSequence) this.pruneLoading.set(false);
    }
  }
  public selectImage(row: Item): void {
    const next = new Set(this.selectedImages());
    const ids = this.imageDigests(row);
    const selected = ids.length > 0 && ids.every((id) => next.has(id));
    for (const id of ids) selected ? next.delete(id) : next.add(id);
    this.selectedImages.set(next);
  }
  public selectAllImages(): void {
    const ids = this.displayed.flatMap((r) => this.imageDigests(r));
    if (ids.length && ids.every((id) => this.selectedImages().has(id)))
      this.selectedImages.set(new Set());
    else this.selectedImages.set(new Set(ids));
  }
  public async selectedPrune(): Promise<void> {
    await this.previewPrune("selection", new Set(this.selectedImages()));
  }
  public imageDelete(row: Item): void {
    if (this.imageWorking) return;
    const ids = this.imageDigests(row);
    const versionIds = new Set<string>((row["versions"] || [row])
      .map((version: Item) => String(version["digest"] || ""))
      .filter(Boolean));
    if (versionIds.size > 1) {
      void this.previewPrune("versions", versionIds, this.imageRef(row));
      return;
    }
    if (ids.length !== 1) return;
    this.confirmAction(
      "로컬 이미지 삭제",
      this.imageRef(row) +
        " · " +
        bytes(row["size"]) +
        "의 이미지를 삭제합니다. 사용 중인 이미지와 보호된 구성 이력은 서버에서 다시 검사합니다.",
      "/servers/" +
        this.selectedServer +
        "/images/" +
        encodeURIComponent(ids[0]) +
        "?confirmed=true",
      {},
      "DELETE",
    );
  }
  public imageUsed(row: Item): boolean {
    return (
      !!row["inUse"] ||
      !!row["containers"]?.length ||
      row["versions"]?.some((version: Item) => version["used"])
    );
  }
  public imageSelected(row: Item): boolean {
    const ids = this.imageDigests(row);
    return ids.length > 0 && ids.every((id) => this.selectedImages().has(id));
  }
  public imageDigests(row: Item): string[] {
    return [
      ...new Set<string>(
        (row["versions"] || [row])
          .filter((version: Item) => !version["used"] && !version["protected"])
          .map((version: Item) => String(version["digest"] || ""))
          .filter(Boolean),
      ),
    ];
  }
  // Preserve group objects across selection changes so list rows keep their scroll and focus.
  public readonly imageGroups = computed<Item[]>(() => {
    const groups = new Map<string, Item>();
    for (const image of this.rows()) {
      const refs = imageReferences(image);
      if (!refs.length) refs.push({ name: "이름 없는 이미지", version: "버전 미지정" });
      for (const ref of refs) {
        const name = ref.name;
        const version = ref.version;
        // Truly unnamed images must remain separate, never one shared deletion row.
        const key = name === "이름 없는 이미지" ? String(image["digest"] || image["id"]) : name;
        let group = groups.get(key);
        if (!group) {
          group = {
            name,
            versions: [],
            size: 0,
            created: image["created"],
            lastUsed: image["lastUsed"],
            protected: false,
            inUse: false,
          };
          groups.set(key, group);
        }
        const used = this.imageUsed(image);
        group["versions"].push({
          label: version,
          digest: image["digest"] || image["id"],
          used,
          protected: !!image["protected"],
        });
        group["size"] = Math.max(
          Number(group["size"] || 0),
          Number(image["size"] || 0),
        );
        group["created"] =
          String(group["created"] || "") > String(image["created"] || "")
            ? group["created"]
            : image["created"];
        group["lastUsed"] =
          String(group["lastUsed"] || "") > String(image["lastUsed"] || "")
            ? group["lastUsed"]
            : image["lastUsed"];
        group["protected"] = !!group["protected"] || !!image["protected"];
        group["inUse"] = !!group["inUse"] || used;
      }
    }
    return [...groups.values()];
  });
  public async macroFiles(): Promise<void> {
    try {
      this.extra.set(items(await wiz.api.get("/macros/" + this.id + "/files")));
    } catch (e) {
      this.error.set(errorMessage(e));
    }
  }
  public async uploadMacro(event: Event): Promise<void> {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    this.busy.set(true);
    try {
      const data = new FormData();
      data.append("file", file);
      await wiz.api.post("/macros/" + this.id + "/files", data);
      await this.macroFiles();
      this.notify("첨부 파일을 저장했습니다.");
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public fileUrl(file: Item): string {
    return wiz.api.url("/macros/" + this.id + "/files/" + file["id"]);
  }
  public wizardZone(): void {
    this.wizardChanged();
    const zone=this.zones().find(z=>z.id===this.draft.zoneId);
    this.draft.domain=zone?this.draft.name+'.'+zone.name:'';
  }

  public cloneTemplate(): void {
    this.openTemplateEditor(this.detail()!, true);
  }
  public async historyRuns(row?: Item): Promise<void> {
    try {
      this.extra.set(
        items(
          await wiz.api.get(
            this.endpoint + "/" + (row?.["id"] || this.id) + "/runs",
          ),
        ),
      );
      this.modalTitle = "실행 이력";
      this.modalDescription = row?.["name"] || this.detail()?.["name"] || "";
      this.modal.set("runs");
    } catch (e) {
      this.error.set(errorMessage(e));
    }
  }
  public passwordLength(value: unknown): number { return Array.from(String(value || "")).length; }
  public async saveSmtp(): Promise<void> {
    if (this.busy()) return;
    this.busy.set(true);
    this.error.set("");
    try {
      const data = this.smtp();
      const payload: Item = {};
      for (const key of ["mailEnabled", "smtpHost", "smtpPort", "smtpUsername", "smtpSenderName"])
        payload[key] = data[key];
      if (data["smtpPassword"]) payload["smtpPassword"] = data["smtpPassword"];
      const saved = await wiz.api.patch<Item>("/anomaly-reports/settings", payload);
      this.smtp.set({ ...saved, smtpPassword: "" });
      this.notify("SMTP 설정을 저장했습니다.");
    } catch (e) { this.error.set(errorMessage(e)); }
    finally { this.busy.set(false); }
  }
  public editorLanguage(field: Field): string {
    return (
      field.language ||
      (/Json$/.test(field.key)
        ? "json"
        : ["compose", "document"].includes(field.key)
          ? "yaml"
          : field.key === "script"
            ? "shell"
            : field.key === "reportTemplate"
              ? "html"
              : "plaintext")
    );
  }
  public testMail(): void {
    this.openModal(
      "form",
      "테스트 메일 발송",
      "저장된 SMTP 설정으로 실제 테스트 메일을 보냅니다.",
      [
        {
          key: "recipient",
          label: "테스트 수신자",
          type: "email",
          required: true,
        },
      ],
      {},
      "/anomaly-reports/test-mail",
    );
  }
  public rotateKey(): void {
    this.openModal(
      "form",
      "SSH 키 교체",
      "새 키로 접속을 확인한 후 자격 증명을 교체합니다.",
      this.serverFields().filter((f) =>
        ["privateKey", "passphrase", "certificate"].includes(f.key),
      ),
      {},
      "/servers/" + this.id + "/credentials",
    );
  }
  public async healthResults(): Promise<void> {
    this.busy.set(true);
    try {
      this.extra.set(items(await wiz.api.get("/service-health")));
      this.modalTitle = "서비스 상태 관측";
      this.modalDescription =
        "서버가 실제 관측한 컨테이너와 서비스의 최근 상태입니다.";
      this.modal.set("health");
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public selectSystemTab(tab: string): void {
    if (!this.systemTabs.some(item => item.id === tab)) return;
    this.systemTab.set(tab);
    void this.router.navigate([], {relativeTo:this.route,queryParams:{tab},queryParamsHandling:"merge"});
  }
  public systemTabKey(event: KeyboardEvent, index: number): void {
    const length = this.systemTabs.length;
    const next = event.key === "ArrowRight" ? (index+1)%length : event.key === "ArrowLeft" ? (index+length-1)%length : event.key === "Home" ? 0 : event.key === "End" ? length-1 : -1;
    if (next < 0) return;
    event.preventDefault();
    this.selectSystemTab(this.systemTabs[next].id);
    document.getElementById("system-tab-"+this.systemTabs[next].id)?.focus();
  }
  public async refreshAgentStatus(force = false): Promise<void> {
    if (this.agentChecking()) return;
    this.agentChecking.set(true);
    this.agentError.set("");
    try {
      this.agentStatus.set(force ? await wiz.api.post<Item>("/agent/status/check", {}) : await wiz.api.get<Item>("/agent/status"));
    } catch (e) {
      this.agentError.set(errorMessage(e));
    } finally {
      this.agentChecking.set(false);
    }
  }
  public async checkAgentVersion(): Promise<void> {
    if (this.agentVersionChecking() || this.maintenanceActive) return;
    this.agentVersionChecking.set(true);
    this.agentVersionError.set("");
    this.agentRelease.set(null);
    try {
      this.agentRelease.set(await wiz.api.get<Item>("/agent/maintenance/latest-version"));
    } catch (e) { this.agentVersionError.set(errorMessage(e)); }
    finally { this.agentVersionChecking.set(false); }
  }
  public get agentVersionComparison(): number | null {
    const current = String(this.agentStatus()["version"] || "");
    const latest = String(this.agentRelease()?.["version"] || "");
    if (!/^\d+\.\d+\.\d+(?:[-+][A-Za-z0-9.-]+)?$/.test(current) || !/^\d+\.\d+\.\d+$/.test(latest)) return null;
    const installed = current.split(/[-+]/)[0].split(".").map(Number);
    const available = latest.split(".").map(Number);
    for (let i = 0; i < 3; i++) if (available[i] !== installed[i]) return Math.sign(available[i] - installed[i]);
    return current.split("+")[0].includes("-") ? 1 : 0;
  }
  public get agentVersionCanInstall(): boolean {
    return !!this.agentRelease() && (this.agentStatus()["binaryAvailable"] === false || this.agentVersionComparison === 1);
  }
  public get agentVersionMessage(): string {
    if (this.agentStatus()["binaryAvailable"] === false) return "확인한 버전을 설치할 수 있습니다.";
    const comparison = this.agentVersionComparison;
    return comparison === 1 ? "새 버전이 있습니다. 버전을 확인한 뒤 업데이트하세요." : comparison === 0 ? "최신 버전을 사용 중입니다." : comparison === -1 ? "설치된 버전이 npm 최신 안정 버전보다 높습니다." : "설치 버전을 확인하지 못했습니다. 인증 상태 확인을 눌러 다시 확인하세요.";
  }
  public get maintenanceActive(): boolean {
    return !!this.agentMaintenance() && !["succeeded","failed","canceled"].includes(this.agentMaintenance()?.["operation"]?.status);
  }
  public showMaintenance(): void {
    this.modalTitle = "Agent 관리 작업";
    this.modalDescription = "작업 상태와 로그인 안내를 확인하세요.";
    this.modalError.set("");
    this.modal.set("agent-maintenance");
  }
  public opLabel(value: string): string {
    value = (value || "").replace(/^deployment-/, "");
    return (
      {
        start: "서비스 시작",
        remove: "서비스 제거",
        "change-image": "이미지 버전 변경",
        rollback: "Compose 롤백",
        verify: "런타임 검증",
        "server-wrapper-upgrade": "실행기 업데이트",
        "server-unregister": "서버 연결 해제",
        "server-repair": "서버 실행 환경 복구",
        "server-optimize": "서버 최적화",
        agent: "Agent 요청",
        "agent-template": "Agent 템플릿 생성",
        "agent-report": "Agent 리포트 분석",
        "agent-macro": "매크로 Agent 작성",
        "agent-apache": "Agent 프록시 구성",
        "agent-server-audit": "Agent 서버 점검",
        "service-migration": "서비스 서버 이동",
        certificate: "인증서 갱신",
        "certificate-issue": "인증서 발급",
        dns: "DNS 변경",
        "domain-apache": "프록시 구성 변경",
        "apache-host": "Apache 호스트 관리",
        "image-prune-preview": "이미지 정리 후보 점검",
        "codex-maintenance": "Agent 관리 작업",
        "container-start": "컨테이너 시작",
        "container-restart": "컨테이너 재시작",
        "container-stop": "컨테이너 중지",
        "container-delete": "컨테이너 삭제",
        "container-prune": "중지 컨테이너 정리",
        "container-change-image": "컨테이너 이미지 변경",
        "container-migrate": "컨테이너 서버 마이그레이션",
        terminal: "터미널 접속",
        "server-setup": "서버 자동 구성",
        "server-check": "서버 연결 점검",
        "service-deploy": "서비스 배포",
        deploy: "서비스 배포",
        "service-stop": "서비스 중지",
        "service-restart": "서비스 재시작",
        restart: "서비스 재시작",
        stop: "서비스 중지",
        "image-pull": "이미지 가져오기",
        "image-import": "이미지 tar 가져오기",
        "image-prune": "미사용 이미지 정리",
        "image-delete": "이미지 삭제",
        "dns-sync": "DNS 동기화",
        "dns-record": "DNS 레코드 변경",
        "macro-run": "매크로 실행",
        "anomaly-report": "운영 리포트 생성",
        "service-health": "서비스 상태 점검",
        "agent-job": "Agent 요청",
        "certificate-check": "인증서 점검",
      }[value] || value
    );
  }
  public editApache(row: Item): void {
    this.openModal(
      "form",
      "Apache 프록시 구성 수정",
      "구문 검사 후 원자적으로 적용합니다. 실패하면 이전 구성을 복구합니다.",
      [
        {
          key: "content",
          label: "VirtualHost 원문",
          language: "apache",
          type: "textarea",
          rows: 22,
          required: true,
        },
      ],
      { content: row["content"] },
      "/services/" + this.id + "/apache/" + row["id"],
      "PUT",
    );
  }
  public async revealCompose(): Promise<void> {
    this.busy.set(true);
    try {
      const result = await wiz.api.get<Item>(
        "/services/" + this.id + "/compose?reveal=true",
      );
      this.form["compose"] =
        typeof result === "string" ? result : result["compose"];
    } catch (e) {
      this.modalError.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public async loadServiceCompose(): Promise<void> {
    const sequence=++this.serviceComposeSequence,id=this.id;
    this.serviceCompose.set('');this.serviceComposeLoading.set(true);this.serviceComposeError.set('');
    try{const result=await wiz.api.get<Item>('/services/'+id+'/compose?reveal=true');
      if(sequence===this.serviceComposeSequence && id===this.id && this.tab==='compose')this.serviceCompose.set(result['compose']);
    }catch(error){if(sequence===this.serviceComposeSequence)this.serviceComposeError.set(errorMessage(error));}
    finally{if(sequence===this.serviceComposeSequence)this.serviceComposeLoading.set(false);}
  }
  public async editServiceCompose(): Promise<void> {
    this.openModal('compose-editor','Compose 구성 편집','이미지 변경을 확인하고 저장합니다. 저장한 구성은 배포 시 실행 환경에 반영됩니다.',[]);
    const sequence=++this.composeSequence, id=this.id;
    this.composeImageChanges.set([]);this.composeLoading.set(true);this.composeLoadError.set('');
    try {
      const result=await wiz.api.get<Item>('/services/'+id+'/compose?reveal=true');
      if(sequence!==this.composeSequence || this.modal()!=='compose-editor' || id!==this.id)return;
      this.composeOriginal=result['compose'];
      this.form={compose:result['compose'],expectedComposeVersion:Number(result['composeVersion'] || this.detail()?.['composeVersion'])};
    } catch(error) { if(sequence===this.composeSequence)this.composeLoadError.set(errorMessage(error)); }
    finally { if(sequence===this.composeSequence)this.composeLoading.set(false); }
  }
  public async saveServiceCompose(confirmed = false): Promise<void> {
    if(this.busy() || this.composeLoading() || this.composeLoadError())return;
    if(!this.form['compose']?.trim()){this.modalError.set('Compose 구성을 입력하세요.');return;}
    if(this.form['compose']===this.composeOriginal){this.closeModal();this.notify('Compose 구성에 변경 사항이 없습니다.');return;}
    this.busy.set(true);this.modalError.set('');
    try {
      if(!confirmed){const plan=await wiz.api.post<Item>('/services/'+this.id+'/compose/plan',{compose:this.form['compose'],expectedComposeVersion:this.form['expectedComposeVersion']});
        if(plan['imageChanges']?.length){this.composeImageChanges.set(plan['imageChanges']);this.modal.set('compose-image-confirm');return;}
      }
      await wiz.api.put('/services/'+this.id,{compose:this.form['compose'],expectedComposeVersion:this.form['expectedComposeVersion'],imageChangesConfirmed:confirmed});
      this.modal.set('');this.form={};this.composeOriginal='';this.composeImageChanges.set([]);this.composeSequence++;
      this.notify('Compose 구성을 저장하고 이력을 기록했습니다. 배포 후 실행 환경에 반영됩니다.');
      await this.load();if(this.tab==='compose')await this.loadServiceCompose();
      setTimeout(()=>this.returnFocus?.focus(),0);
    } catch(error) { this.modalError.set(errorMessage(error)); }
    finally { this.busy.set(false); }
  }
  public async showVersion(version: Item, compare = false): Promise<void> {
    this.openModal('compose-history','Compose v'+version['version']+(compare?' 변경 비교':' 원문'),'저장된 Compose 원문과 비밀값을 포함합니다.',[]);
    this.versionCompare=compare;this.versionContent.set(null);this.versionLoading.set(true);
    const sequence=++this.composeSequence,id=this.id;
    try{const content=await wiz.api.get<Item>('/services/'+id+'/versions/'+version['version']);if(sequence===this.composeSequence&&id===this.id)this.versionContent.set(content);}
    catch(error){if(sequence===this.composeSequence)this.modalError.set(errorMessage(error));}
    finally{if(sequence===this.composeSequence)this.versionLoading.set(false);}
  }
  public migrateService(): void {
    this.openModal(
      "form",
      "서비스 서버 이동",
      "대상 서버를 직접 선택하면 데이터 전송과 중단 영향을 먼저 계산합니다.",
      [
        {
          key: "targetServerId",
          label: "이동할 서버",
          type: "select",
          required: true,
          options: this.serverOptions
            .filter(
              (s) => s["id"] !== this.detail()?.["serverId"] && s["eligible"],
            )
            .map((s) => ({
              value: s["id"],
              label: s["name"] + " · 점수 " + (s["score"] ?? "집계 대기"),
            })),
          hint: "현재 서버를 제외한 배포 가능 서버만 표시합니다.",
        },
      ],
      { targetServerId: "" },
      "/services/" + this.id + "/migrations/plan",
    );
  }
  public async linkServiceDomain(): Promise<void> {
    this.busy.set(true);
    try {
      const [zoneData,linkData] = await Promise.all([wiz.api.get('/dns/zones'),wiz.api.get('/services/'+this.id+'/domains')]);
      const zones=items(zoneData),links=items(linkData);this.serviceDomainLinks.set(links);
      const existing=links.find(link=>link['name']===this.detail()?.['domain']) || links[0];
      if(existing){
        this.openModal('form','서비스 도메인 연결 수정','현재 연결된 Cloudflare DNS와 Apache2 설정을 함께 수정합니다.',[
          {key:'name',label:'서비스 도메인',required:true,placeholder:'예: health',hint:'Zone을 제외한 이름을 입력하세요. @는 Zone 자체를 연결합니다.'},
          {key:'content',label:'DNS 레코드 값',required:true,hint:'Apache2 호스트로 연결되는 IPv4 주소'},
        ],{connectionId:existing['id'],zoneId:existing['zone_id'],name:serviceDomainLabel(zones.find(zone=>zone['id']===existing['zone_id'])?.['name'] || '',existing['name']),zoneName:zones.find(zone=>zone['id']===existing['zone_id'])?.['name'] || '',type:'A',content:existing['content'],ttl:1,proxied:false},'/services/'+this.id+'/domains/'+existing['id'],'PUT');
        return;
      }
      const [certData,targets]=await Promise.all([wiz.api.get('/certificates'),wiz.api.get<Item>('/system/dns-targets')]);
      const certs=items(certData),defaultAddress=/^\d{1,3}(\.\d{1,3}){3}$/.test(targets['defaultAddress'] || '')?targets['defaultAddress']:'';
      this.openModal(
        "form", "서비스 도메인 연결",
        "새 DNS 레코드와 템플릿의 Apache2 설정을 추가합니다. 다음 배포가 성공하면 실제 서비스 포트로 연결됩니다.",
        [
          {key:"zoneId",label:"Cloudflare Zone",type:"select",required:true,options:zones.map(z=>({value:z["id"],label:z["name"]}))},
          {key:"name",label:"새 도메인 이름",required:true,hint:"선택한 Zone 안의 전체 도메인 이름을 입력하세요."},
          {key:"content",label:"DNS 레코드 값",required:true,hint:"Apache2 호스트의 공인 IPv4 주소"},
          {key:"targetHost",label:"프록시 대상 호스트",hint:"비워 두면 선택 서버 주소를 사용합니다."},
          {key:"targetPort",label:"프록시 대상 포트",type:"number",hint:"템플릿에 공개 endpoint가 있으면 배포 시 실제 포트를 사용합니다."},
          {key:"certificateId",label:"Certbot 인증서",type:"select",options:certs.map(c=>({value:c["id"],label:c["name"]})),hint:"선택하지 않으면 배포 시 인증서를 자동 발급해 HTTPS로 연결합니다."},
        ],
        {zoneId:"",name:this.detail()?.['domain'] || '',type:'A',content:defaultAddress,ttl:1,proxied:false,targetHost:"",targetPort:80,certificateId:""},
        "/services/"+this.id+"/domains/new",
      );
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public changedField(key: string): void {

    if (this.isMacroRun && key === 'serverId') {void this.loadMacroTargets();return;}
    if (this.isMacroRun && key === 'serviceId') {this.form['containerId'] = '';return;}
    if (key === "authenticationMethod") {
      delete this.form["password"];
      delete this.form["privateKey"];
      delete this.form["passphrase"];
      delete this.form["certificate"];
    }
    if (key === "thresholdPreset") this.applyReportPreset();
    if (key === "jobType") {
      this.form["targetId"] = "";
      this.form["argsJson"] = "{}";
      this.updateReportSchedule();
      this.previewSchedule();
    }
    if (key === "type" && !["A", "AAAA", "CNAME"].includes(this.form["type"]))
      this.form["proxied"] = false;
  }
  public agentTemplate(): void {
    this.openModal(
      "form",
      "Agent로 템플릿 초안 만들기",
      "필요한 서비스와 입력값을 설명하세요. 초안은 검증을 통과한 후 템플릿으로 저장됩니다.",
      [
        {
          key: "prompt",
          label: "만들고 싶은 서비스 구성",
          type: "textarea",
          rows: 7,
          required: true,
          hint: "사용할 이미지, 공개 포트, 필요한 입력값과 로컬 볼륨을 설명해 주세요.",
        },
      ],
      {},
      "/agent/template-jobs",
    );
  }
  public async editAgentSettings(): Promise<void> {
    this.busy.set(true);
    try {
      const data = await wiz.api.get<Item>("/agent/settings");
      this.openModal(
        "form",
        "인프라 Agent 설정",
        "연결된 실행 환경에서 사용할 모델과 추론 수준을 선택합니다.",
        [
          { key: "enabled", label: "Agent 사용", type: "checkbox" },
          { key: "model", label: "모델 이름", required: true },
          {
            key: "reasoning",
            label: "추론 수준",
            type: "select",
            required: true,
            options: REASONING_OPTIONS,
          },
        ],
        data,
        "/agent/settings",
        "PATCH",
      );
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }

  public async loadEnvironment(reveal = false): Promise<void> {
    const sequence=++this.environmentSequence,id=this.id;
    this.environmentLoading.set(true);this.environmentError.set('');
    if(!reveal){this.environment.set({});this.revealEnv=false;}
    try {
      const data=await wiz.api.get<Item>('/services/'+id+'/environment?reveal='+reveal);
      if(sequence!==this.environmentSequence || id!==this.id || this.tab!=='environment')return;
      this.environment.set(data);
      this.revealEnv = reveal;
    } catch (e) {
      if(sequence===this.environmentSequence)this.environmentError.set(errorMessage(e));
    } finally {
      if(sequence===this.environmentSequence)this.environmentLoading.set(false);
    }
  }
  public environmentComponentKey(index: number, component: Item): string {return component['component'] || String(index);}
  public get isServiceDomainEdit(): boolean {return this.modal()==='form' && this.actionMethod==='PUT' && /^\/services\/[^/]+\/domains\/[^/]+$/.test(this.actionEndpoint);}
  public get selectedServiceDomain(): Item | undefined {return this.serviceDomainLinks().find(link=>link['id']===this.form['connectionId']);}
  public async loadLogs(silent = false): Promise<void> {
    if (!this.logComponent || this.logsLoading()) return;
    const sequence=++this.logsSequence,id=this.id,component=this.logComponent;this.logsLoading.set(true);if(!silent)this.modalError.set('');
    try {
      const data=await wiz.api.get<Item>('/services/'+id+'/logs?component='+encodeURIComponent(component));
      if(sequence!==this.logsSequence||id!==this.id||this.modal()!=='container-logs')return;
      const scrollTop=this.runtimeLogOutput?.nativeElement.scrollTop || 0;
      this.logSnapshot.set([data['stdout'],data['stderr']].filter(Boolean).join('\n'));this.logsLoaded=true;
      requestAnimationFrame(()=>{if(sequence!==this.logsSequence || this.modal()!=='container-logs')return;const output=this.runtimeLogOutput?.nativeElement;if(output)output.scrollTop=this.followLogs?output.scrollHeight:scrollTop;});
    }catch(error){if(sequence===this.logsSequence){this.modalError.set(errorMessage(error));this.followLogs=false;}}
    finally{if(sequence===this.logsSequence)this.logsLoading.set(false);}
  }
  public setLogFollow(enabled: boolean): void {
    this.followLogs=enabled;
    if(enabled){this.scrollLogsToBottom();void this.loadLogs(true);}
  }
  public setLogTimestamps(enabled: boolean): void {
    const scrollTop=this.runtimeLogOutput?.nativeElement.scrollTop || 0;
    this.showLogTimestamps=enabled;
    requestAnimationFrame(()=>{const output=this.runtimeLogOutput?.nativeElement;if(output)output.scrollTop=this.followLogs?output.scrollHeight:scrollTop;});
  }
  private scrollLogsToBottom(): void {requestAnimationFrame(()=>{const output=this.runtimeLogOutput?.nativeElement;if(output && this.followLogs)output.scrollTop=output.scrollHeight;});}
  public toggleRuntimeSize(): void {this.runtimeModalFullsize=!this.runtimeModalFullsize;this.scrollLogsToBottom();}
  public showLogs(row: Item): void {
    this.openModal('container-logs',this.componentName(row)+' · 컨테이너 로그','최근 컨테이너 출력을 조회합니다.',[]);
    this.logsSequence++;this.logsLoading.set(false);this.logsLoaded=false;this.logComponent=this.componentName(row);this.logSnapshot.set('');this.followLogs=false;this.showLogTimestamps=true;void this.loadLogs();
  }
  public showTerminal(row: Item): void {
    this.terminalComponent=this.componentName(row);
    this.openModal('container-terminal',this.terminalComponent+' · 컨테이너 터미널','컨테이너에 연결해 명령을 실행합니다.',[]);
  }
  public componentName(row: Item): string {
    return row["component"] || row["Service"] || row["service"] || "";
  }
  public containerAction(action: string, row: Item): void {
    const component = this.componentName(row);
    this.confirmAction(
      component +
        " " +
        { start: "시작", restart: "재시작", stop: "중지" }[action],
      this.detail()?.["name"] + " 서비스의 선택한 구성요소에서 실행합니다.",
      "/services/" + this.id + "/deployments",
      { action, component, serverId: this.detail()?.["serverId"] },
    );
  }
  public deleteMetrics(): void {
    let range: {from:string;to:string};
    try { range = this.resourceRange(); } catch (e) { this.error.set(errorMessage(e)); return; }
    this.confirmAction(
      "선택 기간의 지표 삭제",
      date(range.from) +
        "부터 " +
        date(range.to) +
        "까지 수집한 지표를 삭제합니다. 배포 점수와 분석에 영향을 줄 수 있으며 되돌릴 수 없습니다.",
      "/servers/" + this.id + "/metrics",
      {
        from: range.from,
        to: range.to,
        confirmed: true,
      },
      "DELETE",
    );
  }
  public async probeSettings(): Promise<void> {
    this.busy.set(true);
    try {
      const [data, links] = await Promise.all([
        wiz.api.get<Item>("/service-health/settings/" + this.id),
        wiz.api.get("/services/" + this.id + "/domains"),
      ]);
      this.openModal(
        "form",
        "서비스 상태 점검 설정",
        "Docker 상태와 함께 HTTP / TCP 응답을 관측합니다. 주소는 연결한 서버 또는 서비스 도메인으로 제한됩니다.",
        [
          { key: "enabled", label: "서비스 상태 점검 사용", type: "checkbox" },
          {
            key: "hostMode",
            label: "점검 대상 주소",
            type: "select",
            options: [
              { value: "server", label: "서비스가 실행 중인 서버" },
              { value: "domain", label: "연결한 서비스 도메인" },
            ],
          },
          {
            key: "domainId",
            label: "연결 도메인",
            type: "select",
            options: items(links).map((l) => ({
              value: l["id"],
              label: l["name"],
            })),
          },
          { key: "httpEnabled", label: "HTTP 상태 점검", type: "checkbox" },
          {
            key: "httpScheme",
            label: "HTTP 프로토콜",
            type: "select",
            options: [
              { value: "http", label: "HTTP" },
              { value: "https", label: "HTTPS" },
            ],
          },
          { key: "httpPort", label: "HTTP 포트", type: "number" },
          { key: "httpPath", label: "HTTP 경로" },
          { key: "expectedStatus", label: "정상 응답 코드", type: "number" },
          { key: "tcpEnabled", label: "TCP 연결 점검", type: "checkbox" },
          { key: "tcpPort", label: "TCP 포트", type: "number" },
          {
            key: "timeoutSeconds",
            label: "응답 제한 시간 (초)",
            type: "number",
            required: true,
          },
          {
            key: "failureThreshold",
            label: "연속 실패 경고 기준 (회)",
            type: "number",
            required: true,
          },
        ],
        data,
        "/service-health/settings/" + this.id,
        "PUT",
      );
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public async loadServiceHealth(more = false): Promise<void> {
    if(this.healthHistoryLoading())return;
    const sequence=++this.healthHistorySequence,id=this.id,page=more?this.healthPage+1:1;
    this.healthHistoryLoading.set(true);this.healthHistoryError.set('');
    try {
      if(!more){if(!this.healthDateFrom || !this.healthDateTo || this.healthDateFrom>this.healthDateTo)throw new Error('조회 시작일과 종료일을 확인해 주세요.');this.appliedHealthFilter={from:this.healthDateFrom+'T00:00:00+09:00',to:new Date(Date.parse(this.healthDateTo+'T00:00:00+09:00')+86400000).toISOString(),status:this.healthStatus};}
      const filter=this.appliedHealthFilter!;
      const query=new URLSearchParams({serviceId:id,page:String(page),size:'20',from:filter.from,to:filter.to});if(filter.status)query.set('status',filter.status);
      const [data,settings]=await Promise.all([wiz.api.get('/service-health?'+query),wiz.api.get<Item>('/service-health/settings/'+id)]);
      if(sequence!==this.healthHistorySequence || id!==this.id || this.tab!=='service-health')return;
      const rows=items(data);this.healthHistory.set(more?[...this.healthHistory(),...rows]:rows);this.healthPage=page;this.healthHasMore=rows.length===20;
      this.serviceProbeSettings.set(settings);
    } catch(error) { if(sequence===this.healthHistorySequence)this.healthHistoryError.set(errorMessage(error)); }
    finally { if(sequence===this.healthHistorySequence)this.healthHistoryLoading.set(false); }
  }
  public async runServiceHealth(): Promise<void> {
    if(this.busy() || this.healthWorking || !this.serviceProbeSettings()?.['enabled'])return;
    this.busy.set(true);this.healthHistoryError.set('');
    try {
      const op=await wiz.api.post<Item>('/service-health/runs',{serviceId:this.id});
      this.healthOperation.set(op);this.healthOperationSequence++;
      void this.pollServiceHealth();
    } catch(error) { this.healthHistoryError.set(errorMessage(error)); }
    finally { this.busy.set(false); }
  }
  private async pollServiceHealth(): Promise<void> {
    if(this.healthPolling || !this.healthWorking)return;
    const sequence=this.healthOperationSequence,opId=this.healthOperation()!['id'];this.healthPolling=true;
    try {
      const op=await wiz.api.get<Item>('/operations/'+opId);
      if(sequence!==this.healthOperationSequence)return;
      this.healthOperation.set(op);
      if(!this.healthWorking && this.tab==='service-health')await this.loadServiceHealth();
    } catch(error) { if(sequence===this.healthOperationSequence)this.healthHistoryError.set(errorMessage(error)); }
    finally { this.healthPolling=false; }
  }
  public async moreTemplates(): Promise<void> {
    this.busy.set(true);
    try {
      const next = items(
        await wiz.api.get(
          "/templates?page=" + (this.templatePage + 1) + "&size=20",
        ),
      );
      this.templatePage++;
      this.templates.update((t) => [...t, ...next]);
      this.templateHasMore = next.length === 20;
    } catch (e) {
      this.modalError.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public startMaintenance(action: string): void {
    if (action !== "login" && !this.agentVersionCanInstall) return;
    const version = action === "login" ? null : this.agentRelease()!["version"];
    this.openModal(
      "form",
      action === "login"
        ? "Agent 기기 로그인"
        : action === "install"
          ? "Agent 설치"
          : "Agent 업데이트",
      action === "login"
        ? "표시된 인증 경로에 기기 로그인을 시작합니다. 다음 화면에서 안내하는 주소와 코드를 사용하세요."
        : `확인한 @openai/codex ${version} 버전을 앱 관리 경로에 설치합니다. 설치와 실행 검증이 끝나면 적용되며, 기존 인증과 대화 기록은 유지됩니다.`,
      [
        {
          key: "confirmed",
          label: "선택한 Agent 관리 작업을 실행합니다",
          type: "checkbox",
        },
      ],
      { action, version, confirmed: false },
      "/agent/maintenance",
    );
  }
  public async pollMaintenance(): Promise<void> {
    const id = this.agentMaintenance()?.["operation"]?.id;
    if (!id || !this.maintenanceActive || this.maintenancePolling) return;
    this.maintenancePolling = true;
    try {
      this.agentMaintenance.set(await wiz.api.get<Item>("/agent/maintenance/" + id));
      this.modalError.set("");
      if (!this.maintenanceActive) await this.refreshAgentStatus(true);
    } catch (e) {
      this.modalError.set(errorMessage(e));
    } finally {
      this.maintenancePolling = false;
    }
  }
  public async cancelMaintenance(): Promise<void> {
    this.busy.set(true);
    try {
      this.agentMaintenance.set(
        await wiz.api.post<Item>(
          "/agent/maintenance/" +
            this.agentMaintenance()?.["operation"]?.id +
            "/cancel",
        ),
      );
      await this.refreshAgentStatus(true);
    } catch (e) {
      this.modalError.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public minutes(seconds: any): string {
    return seconds == null
      ? "—"
      : Math.round(Number(seconds) / 60).toLocaleString("ko-KR") + "분";
  }
  public async statistics(): Promise<void> {
    this.busy.set(true);
    try {
      const range = this.resourceRange();
      this.metricStats.set(
        items(
          await wiz.api.get(
            "/servers/" +
              this.id +
              "/metrics/statistics?from=" +
              encodeURIComponent(range.from) +
              "&to=" +
              encodeURIComponent(range.to) +
              "&bucketMinutes=60",
          ),
        ),
      );
      this.modalTitle = "시간대별 자원 통계";
      this.modalDescription =
        "선택 기간의 실제 수집값을 최소 · 평균 · 최대 사용률로 집계합니다.";
      this.modal.set("statistics");
    } catch (e) {
      this.error.set(errorMessage(e));
    } finally {
      this.busy.set(false);
    }
  }
  public broadcastContext(): void {
    window.dispatchEvent(
      new CustomEvent("infra-context", {
        detail: {
          route: this.router.url,
          entityId: this.id || null,
          selectedTab: this.tab,
          title: this.id
            ? this.detail()?.["name"] ||
              this.detail()?.["type"] ||
              this.title + " 상세"
            : this.title,
          validationErrors: [this.error(), this.modalError()].filter(Boolean),
        },
      }),
    );
  }
  public repairServer(): void {
    this.openModal(
      "form",
      "서버 실행 환경 복구",
      "선택한 시스템 서비스를 재시작합니다. Docker 재시작은 운영 중인 컨테이너에 영향을 줄 수 있습니다.",
      [
        {
          key: "target",
          label: "복구 대상",
          type: "select",
          required: true,
          options: [
            ...(this.detail()?.["executionMode"] === "local"
              ? []
              : [{ value: "reporter", label: "수집 Agent" }]),
            { value: "docker", label: "Docker" },
          ],
        },
      ],
      { target: "" },
      "/servers/" + this.id + "/repair",
    );
  }
  public toggleService(row: Item): void {
    const next = new Map(this.selectedServices());
    if (next.has(row["id"])) next.delete(row["id"]);
    else next.set(row["id"], row["name"]);
    this.selectedServices.set(next);
  }
  public toggleAllServices(): void {
    const next = new Map(this.selectedServices());
    const remove = this.displayed.every((r) => next.has(r["id"]));
    for (const row of this.displayed) {
      if (remove) next.delete(row["id"]);
      else next.set(row["id"], row["name"]);
    }
    this.selectedServices.set(next);
  }
  public bulkServices(action: string): void {
    const names = Array.from(this.selectedServices().values()).join(", ");
    this.confirmAction(
      "선택 서비스 " +
        { deploy: "배포", restart: "재시작", stop: "중지", remove: "제거" }[
          action
        ],
      names +
        " · 각 서비스에 저장된 실행 서버에서 작업합니다." +
        (action === "remove" ? " 서비스 데이터는 보존합니다." : ""),
      "/services/bulk-actions",
      { ids: Array.from(this.selectedServices().keys()), action },
    );
  }
  public quickCron(value: string): void {
    this.form["cron"] = value;
    this.previewSchedule();
  }
  public escape(event: KeyboardEvent): void {
    if (event.key === "Escape") {
      this.closeModal();
      this.closeWizard();
    }
    if (event.key === "Tab") {
      if (event.defaultPrevented) return;
      const el = event.currentTarget as HTMLElement;
      const nodes = Array.from(
        el.querySelectorAll<HTMLElement>(
          "button:not([disabled]),input,select,textarea,a[href]",
        ),
      ).filter((n) => n.offsetParent !== null);
      if (!nodes.length) return;
      const first = nodes[0],
        last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }
}

interface FeedbackPanel { feedback?: TemplateRef<unknown>; }
interface ContainerPanel extends FeedbackPanel { loading: Signal<boolean>; load():Promise<void>; }

export default ComponentConsoleComponent;
